import React, { useState, useEffect, useRef } from "react";
// import toast from 'react-hot-toast';
import Row from "react-bootstrap/Row";
import Col from "react-bootstrap/Col";
import DataTable from "react-data-table-component";
import { useNavigate } from "react-router-dom";
import toast from "react-hot-toast";

//Redux
import { useDispatch, useSelector } from "react-redux"; //useDispatch.
import ShowHorizontalStatus from "../../../Components/Modal/supplier_app/Workflow/ShowHorizontalStatus";

//Components
import Layout from "../../../Layout/Layout";
import Constants from "../../../common/SupplierConstants";
import CommonItemLevelDatatableModal from "../../../Components/Modal/supplier_app/CommonItemLevelDatatableModal";
import {
  addASNDetailNumber,
  addGRNDetailNumber,
  addInvoiceDetailNumber,
  addPoSelectedDetails,
  addSelectedItemList,
  addSesDetailNumber,
  addSubTransactionActivity,
  getPurchaseOrder,
  getSchedulingAgreement,
  getServicePO,
} from "../../../redux/feature/supplier_app/purchasingSlice";
import { InputField } from "../../../Components/formElements/InputField";
// import POCollabrationCommonFillter from "../../../Components/Filter/POCollabration/POCollabrationCommonFillter";

//Serivce
import ItemService from "../../../services/supplier_appCommonService";
import ItemServiceV1 from "../../../services/inventory_appCommonService";
import {
  capitalize,
  currencyFormat,
  formatDate,
} from "../../../common/Validations";
import WorkflowApproveReject from "../../../Components/Workflow/WorkflowApproveReject";
import { TableStatusField } from "../../../Components/formElements/TableStatusField";
import { TextAreaField } from "../../../Components/formElements/TextAreaField";
import DraftModal from "../../../Components/CancleModal/DraftModal";

const PurchaseOrderDetailPageWH = () => {
  const dispatch = useDispatch();
  const navigate = useNavigate();
  const divRef = useRef(null);
  const historyGuardRef = useRef(false);
  const initialFormRef = useRef(null);
  const [getHeaderData, setHeaderData] = useState(false);
  const [showDraftModal, setShowDraftModal] = useState(false);

  const status = getHeaderData?.headerStatus?.toLowerCase();

  const formInputsRef = useRef(getHeaderData);
  const hasFormChanges = () => {
    return JSON.stringify(formInputsRef.current) !== initialFormRef.current;
  };
  useEffect(() => {
    formInputsRef.current = getHeaderData;
  }, [getHeaderData]);
  const handleDiscardDraft = () => {
    setShowDraftModal(false);
    setIsEditMode(false);
    historyGuardRef.current = false;
    loadInitialPageData();
  };

  let userData = useSelector((state) => state?.user); // User Details from Store

  let getConstantVar = useSelector((state) => state?.common?.data); // User getConstantVar from Store
  let userInfo = useSelector((state) => state?.user?.data); // User Details from Store
  let purchase_order_data = useSelector(
    (state) => state?.purchasing?.purchase_order?.data,
  ); // purchase_order_data Details from Store
  let poNumber = useSelector(
    (state) => state?.purchasing?.purchase_order?.poNumber,
  ); // purchase_order from Store
  let workflow = useSelector(
    (state) => state?.purchasing?.purchase_order?.workflowPO,
  ); // workflowPO from Store
  let service_po_data = useSelector(
    (state) => state?.purchasing?.purchase_order?.service_po?.data,
  );

  let scheduling_agreement_data = useSelector(
    (state) => state?.purchasing?.purchase_order?.scheduling_agreement?.data,
  );

  const [isEditMode, setIsEditMode] = useState(false);
  // eslint-disable-next-line
  const [editedHeaderData, setEditedHeaderData] = useState({});

  const [editedItems, setEditedItems] = useState({});
  const handleItemFieldChange = (itemNr, field, value, row) => {
    setEditedItems((prev) => {
      const currentEdit = prev[itemNr] || { ...row };

      const updatedEdit = {
        ...currentEdit,
        [field]: value,
      };

      const qty = Number(updatedEdit.purchaseQuantity || 0);
      const price = Number(updatedEdit.orderPriceUnit || 0);
      const tax = Number(updatedEdit.taxCode || 0);

      updatedEdit.netValue = (qty * price).toFixed(2);
      updatedEdit.taxAmount = ((qty * price * tax) / 100).toFixed(2);

      return {
        ...prev,
        [itemNr]: updatedEdit,
      };
    });
  };
  // const handleItemFieldChange = (itemNr, field, value, row) => {
  //   setEditedItems((prev) => {
  //     const currentEdit = prev[itemNr] || {};

  //     const updatedEdit = {
  //       ...currentEdit,
  //       [field]: value,
  //     };

  //     const qty =
  //       field === "purchaseQuantity"
  //         ? Number(value)
  //         : Number(updatedEdit.purchaseQuantity ?? row.purchaseQuantity ?? 0);

  //     const price =
  //       field === "orderPriceUnit"
  //         ? Number(value)
  //         : Number(updatedEdit.orderPriceUnit ?? row.orderPriceUnit ?? 0);

  //     const tax =
  //       field === "taxCode"
  //         ? Number(value)
  //         : Number(updatedEdit.taxCode ?? row.taxCode ?? 0);

  //     updatedEdit.netValue = (qty * price).toFixed(2);
  //     updatedEdit.taxAmount = ((qty * price * tax) / 100).toFixed(2);

  //     return {
  //       ...prev,
  //       [itemNr]: updatedEdit,
  //     };
  //   });
  // };
  const handleUpdateClick = () => {
    const formattedRows = (data || []).map((item, index) => ({
      localid: index + 1,
      purchasingDocumentNr: item.purchasingDocumentNr || poNumber || "",
      purchasingDocumentItemNr: item.purchasingDocumentItemNr || "",
      itemTextData: item.itemTextData || [],
      statusItem: item.statusItem || "In Release",
      materialCode: item.materialCode || "",
      materialDescription: item.materialDescription || "",
      materialGroup: item.materialGroup || "",
      purchaseQuantity: item.purchaseQuantity || "",
      orderUnitOfMeasure: item.orderUnitOfMeasure || "",
      orderPriceUnit: item.orderPriceUnit || "",
      netValue: item.netValue || 0,
      currencyCode: item.currencyCode || "INR",
      taxAmount: item.taxAmount || 0,
      taxCode: item.taxCode || 0,
      deliveryDate: item.deliveryDate || "",
      plant: item.plant || "",
      storageLocn: item.storageLocn || "",
      isNew: false,
    }));

    setPOLineItemsData(formattedRows);

    const initialEdits = {};
    (data || []).forEach((row) => {
      const qty = Number(row.purchaseQuantity || 0);
      const price = Number(row.orderPriceUnit || 0);

      initialEdits[row.purchasingDocumentItemNr] = {
        purchaseQuantity: row.purchaseQuantity || "",
        orderPriceUnit: row.orderPriceUnit || "",
        netValue: qty * price,
      };
    });

    setEditedItems(initialEdits);
    setIsEditMode(true);
  };

  const activePoData =
    getHeaderData?.purchaseTypeCode === "SER"
      ? service_po_data
      : getHeaderData?.purchaseTypeCode === "SA"
        ? scheduling_agreement_data
        : purchase_order_data;

  const workflows =
    (Array.isArray(activePoData) ? activePoData : []).find(
      (item) => item.documentNumber === poNumber,
    )?.workflowActionLogs || [];

  let config = useSelector(
    (state) => state?.common?.data?.purchaseOrder?.poDetailsPage,
  ); // config Details from Store
  const [data, setData] = useState([]);
  const [loading, setLoading] = useState(false);

  const [isCardVisible, setCardVisible] = useState(true);
  const [isCardVisible2, setCardVisible2] = useState(true);
  const [isCardVisible3, setCardVisible3] = useState(true);
  const [isCardVisible4, setCardVisible4] = useState(true);
  const [isCardVisible5, setCardVisible5] = useState(true);
  const [isCardVisible6, setCardVisible6] = useState(true);

  const [getItemLevelData, setItemLevelData] = useState([]);
  const [getItemLevelColumns, setItemLevelColumns] = useState([]);
  const [getModalTitle, setModalTitle] = useState("");

  const [getViewHeaderText, setViewHeaderText] = useState(false);
  const [showWorkflow, setShowWorkflow] = useState(false);

  const [disabled, setDisabled] = useState(false);
  // eslint-disable-next-line
  const [getSelectedData, setSelectedData] = useState([]);
  const [toggleCleared, setToggleCleared] = useState(false);

  const [getGrnHistoricalData, setGrnHistoricalData] = useState([]);
  const [getAsnHistoricalData, setAsnHistoricalData] = useState([]);
  const [getInvoiceHistoricalData, setInvoiceHistoricalData] = useState([]);
  const [getSesHistoricalData, setSesHistoricalData] = useState([]);

  // eslint-disable-next-line no-unused-vars
  const [getTwoWayMatch, setTwoWayMatch] = useState([]);
  const [getThreeWayMatch, setThreeWayMatch] = useState([]);
  const [getPOLineItemsData, setPOLineItemsData] = useState();

  const handleCancelClick = () => {
    if (hasFormChanges()) {
      setShowDraftModal(true);
    } else {
      setIsEditMode(false);
      historyGuardRef.current = false;
    }
  };
  const addPOItemRow = () => {
    setPOLineItemsData((prev) => {
      const nextId = (prev?.length || 0) + 1;

      return [
        ...prev,
        {
          localid: nextId,
          purchasingDocumentNr: poNumber || "",
          purchasingDocumentItemNr: "",
          itemTextData: [],
          statusItem: "In Release",
          materialCode: "",
          materialDescription: "",
          materialGroup: "",
          purchaseQuantity: "",
          orderUnitOfMeasure: "",
          orderPriceUnit: "",
          netValue: 0,
          currencyCode: "INR",
          taxAmount: 0,
          taxCode: 0,
          deliveryDate: "",
          plant: "",
          storageLocn: "",
          isNew: true,
        },
      ];
    });
  };
  useEffect(() => {
    if (getHeaderData?.purchaseTypeCode === "MAT" && Array.isArray(data)) {
      const formattedRows = data.map((item, index) => ({
        local_id: index + 1,
        purchasingDocumentNr: item.purchasingDocumentNr || poNumber || "",
        purchasingDocumentItemNr: item.purchasingDocumentItemNr || "",
        itemTextData: item.itemTextData || [],
        materialCode: item.materialCode || "",
        materialDescription: item.materialDescription || "",
        materialGroup: item.materialGroup || "",
        purchaseQuantity: item.purchaseQuantity || "",
        orderUnitOfMeasure: item.orderUnitOfMeasure || "",
        orderPriceUnit: item.orderPriceUnit || "",
        netValue: item.netValue || 0,
        currencyCode: item.currencyCode || "INR",
        taxAmount: item.taxAmount || 0,
        taxCode: item.taxCode || 0,
        deliveryDate: item.deliveryDate || "",
        plant: item.plant || "",
        storageLocn: item.storageLocn || "",
        isOld: true,
      }));

      setPOLineItemsData(formattedRows);
    }
  }, [data, getHeaderData?.purchaseTypeCode, poNumber]);
  // const handleInputChange = (rowId, event, type = "", calcType = "") => {
  //   const { name, value } = event.target;

  //   setPOLineItemsData((prev) =>
  //     prev.map((row) => {
  //       if (row.local_id !== rowId) return row;

  //       let updatedValue = value;

  //       if (type === "Number") {
  //         updatedValue = value === "" ? "" : Number(value);
  //       }

  //       const updatedRow = {
  //         ...row,
  //         [name]: updatedValue,
  //       };

  //       const qty = Number(updatedRow.purchaseQuantity || 0);
  //       const price = Number(updatedRow.orderPriceUnit || 0);
  //       const tax = Number(updatedRow.taxCode || 0);

  //       updatedRow.netValue = qty * price;
  //       updatedRow.taxAmount = (updatedRow.netValue * tax) / 100;

  //       return updatedRow;
  //     }),
  //   );
  // };

  const handleInputChange = (rowId, event, type = "") => {
    const { name, value } = event.target;

    setPOLineItemsData((prev) =>
      prev.map((row) => {
        if (row.localid !== rowId) return row;

        let updatedValue = value;
        if (type === "Number") {
          updatedValue = value === "" ? "" : Number(value);
        }

        const updatedRow = {
          ...row,
          [name]: updatedValue,
        };

        const qty = Number(updatedRow.purchaseQuantity || 0);
        const price = Number(updatedRow.orderPriceUnit || 0);
        const tax = Number(updatedRow.taxCode || 0);

        updatedRow.netValue = qty * price;
        updatedRow.taxAmount = (updatedRow.netValue * tax) / 100;

        return updatedRow;
      }),
    );
  };
  const handleSaveClick = async () => {
    const toastId = toast.loading("Saving...", { position: "top-right" });

    try {
      // Existing items that were edited
      const updatedOldItems = Object.entries(editedItems)
        .filter(([itemNr, values]) => {
          const originalRow = data.find(
            (row) => String(row.purchasingDocumentItemNr) === String(itemNr),
          );

          return (
            String(values.purchaseQuantity) !==
              String(originalRow?.purchaseQuantity ?? "") ||
            String(values.orderPriceUnit) !==
              String(originalRow?.orderPriceUnit ?? "") ||
            String(values.taxCode) !== String(originalRow?.taxCode ?? "") ||
            String(values.materialCode) !==
              String(originalRow?.materialCode ?? "") ||
            String(values.materialDescription) !==
              String(originalRow?.materialDescription ?? "") ||
            String(values.deliveryDate) !==
              String(originalRow?.deliveryDate ?? "") ||
            String(values.plant) !== String(originalRow?.plant ?? "") ||
            String(values.storageLocn) !==
              String(originalRow?.storageLocn ?? "")
          );
        })
        .map(([itemNr, values]) => ({
          purchasingDocumentItemNr: itemNr,
          ...values,
        }));

      // Newly added items
      const addedNewItems = (getPOLineItemsData || [])
        .filter((row) => row.isNew)
        .map((row) => ({
          materialCode: row.materialCode || "",
          materialDescription: row.materialDescription || "",
          materialGroup: row.materialGroup || "",
          purchaseQuantity: row.purchaseQuantity || 0,
          orderUnitOfMeasure: row.orderUnitOfMeasure || "",
          orderPriceUnit: row.orderPriceUnit || 0,
          netValue: row.netValue || 0,
          currencyCode: row.currencyCode || "INR",
          taxAmount: row.taxAmount || 0,
          taxCode: row.taxCode || 0,
          deliveryDate: row.deliveryDate || "",
          plant: row.plant || "",
          storageLocn: row.storageLocn || "",
        }));

      const items = [...updatedOldItems, ...addedNewItems];

      if (items.length === 0) {
        toast.dismiss(toastId);
        toast.error("No changes to save");
        return;
      }

      const payload = {
        documentNumber: poNumber,
        items,
      };

      const res = await ItemServiceV1.updatePOWH(payload);

      if (res?.status === 200) {
        toast.success(res?.message || "Updated successfully", {
          duration: 3000,
          position: "top-right",
        });

        // Clear edit state
        setEditedItems({});
        setIsEditMode(false);

        // Reload latest data from DB
        await loadInitialPageData();
      } else {
        toast.error(res?.message || "Please try again !!", {
          duration: 4000,
          position: "top-right",
        });
      }
    } catch (error) {
      toast.error(error?.message || "Something went wrong", {
        duration: 4000,
        position: "top-right",
      });
    } finally {
      toast.dismiss(toastId);
    }
  };
  // const handleSaveClick = async () => {
  //   const toastId = toast.loading("Saving...", { position: "top-right" });

  //   try {
  //     // const updatedOldItems = Object.entries(editedItems)
  //     //   .filter(([itemNr, values]) => {
  //     //     const originalRow = data.find(
  //     //       (row) => String(row.purchasingDocumentItemNr) === String(itemNr),
  //     //     );

  //     //     return (
  //     //       String(values.purchaseQuantity) !==
  //     //         String(originalRow?.purchaseQuantity ?? "") ||
  //     //       String(values.orderPriceUnit) !==
  //     //         String(originalRow?.orderPriceUnit ?? "")
  //     //     );
  //     //   })
  //     //   .map(([itemNr, values]) => ({
  //     //     purchasingDocumentItemNr: itemNr,
  //     //     purchaseQuantity: values.purchaseQuantity,
  //     //     orderPriceUnit: values.orderPriceUnit,
  //     //     netValue: values.netValue,
  //     //   }));
  //     const updatedOldItems = Object.entries(editedItems)
  //       .filter(([itemNr, values]) => {
  //         const originalRow = data.find(
  //           (row) => String(row.purchasingDocumentItemNr) === String(itemNr),
  //         );

  //         return (
  //           String(values.purchaseQuantity) !==
  //             String(originalRow?.purchaseQuantity ?? "") ||
  //           String(values.orderPriceUnit) !==
  //             String(originalRow?.orderPriceUnit ?? "") ||
  //           String(values.taxCode) !== String(originalRow?.taxCode ?? "")
  //         );
  //       })
  //       .map(([itemNr, values]) => ({
  //         purchasingDocumentItemNr: itemNr,
  //         purchaseQuantity: values.purchaseQuantity,
  //         orderPriceUnit: values.orderPriceUnit,
  //         taxCode: values.taxCode,
  //         taxAmount: values.taxAmount,
  //         netValue: values.netValue,
  //       }));

  //     const addedNewItems = getPOLineItemsData
  //       .filter((row) => row.isNew)
  //       .map((row) => ({
  //         materialCode: row.materialCode || "",
  //         materialDescription: row.materialDescription || "",
  //         materialGroup: row.materialGroup || "",
  //         purchaseQuantity: row.purchaseQuantity || 0,
  //         orderUnitOfMeasure: row.orderUnitOfMeasure || "",
  //         orderPriceUnit: row.orderPriceUnit || 0,
  //         netValue: row.netValue || 0,
  //         currencyCode: row.currencyCode || "INR",
  //         taxAmount: row.taxAmount || 0,
  //         taxCode: row.taxCode || 0,
  //         deliveryDate: row.deliveryDate || "",
  //         plant: row.plant || "",
  //         storageLocn: row.storageLocn || "",
  //       }));

  //     const items = [...updatedOldItems, ...addedNewItems];

  //     if (items.length === 0) {
  //       toast.dismiss(toastId);
  //       toast.error("No changes to save");
  //       return;
  //     }

  //     const payload = {
  //       documentNumber: poNumber,
  //       items: [...updatedOldItems, ...addedNewItems],
  //     };

  //     const res = await ItemServiceV1.updatePOWH(payload);

  //     if (res?.status === 200) {
  //       toast.success(res?.message || "Updated successfully", {
  //         duration: 3000,
  //         position: "top-right",
  //       });

  //       setData((prev = []) => {
  //         const updatedRows = prev.map((row) => {
  //           const updated = updatedOldItems.find(
  //             (item) =>
  //               String(item.purchasingDocumentItemNr) ===
  //               String(row.purchasingDocumentItemNr),
  //           );
  //           return updated ? { ...row, ...updated } : row;
  //         });

  //         return [
  //           ...updatedRows,
  //           ...getPOLineItemsData.filter((row) => row.isNew),
  //         ];
  //       });

  //       setPOLineItemsData((prev = []) =>
  //         prev.map((row) => ({ ...row, isNew: false })),
  //       );

  //       setEditedItems({});
  //       setIsEditMode(false);
  //     } else {
  //       toast.error(res?.message || "Please try again !!", {
  //         duration: 4000,
  //         position: "top-right",
  //       });
  //     }
  //   } catch (error) {
  //     toast.error(error?.message || "Something went wrong", {
  //       duration: 4000,
  //       position: "top-right",
  //     });
  //   } finally {
  //     toast.dismiss(toastId);
  //   }
  // };
  const handleSaveAsDraft = async (payload) => {
    const toastId = toast.loading("Saving as draft...", {
      position: "top-right",
    });

    try {
      const draftPayload = {
        ...payload,
      };

      const response = await ItemService.updatePOWH(draftPayload);

      toast.dismiss(toastId);

      if (response?.status === 200) {
        toast.success("Saved as draft successfully", {
          position: "top-right",
        });
        setShowDraftModal(false);
        setIsEditMode(false);
        initialFormRef.current = JSON.stringify(getHeaderData);
        historyGuardRef.current = false;
        loadInitialPageData();
      } else {
        toast.error(response?.message || "Failed to save draft", {
          position: "top-right",
        });
      }

      return response;
    } catch (error) {
      console.error(error);
      toast.dismiss(toastId);
      toast.error("Something went wrong. Please try again.", {
        position: "top-right",
      });
      throw error;
    }
  };
  const handleConvertToPO = async () => {
    let obj = {
      data: getHeaderData,
      type: "Save",
    };
    await ItemServiceV1.addPOWH(obj).then((item) => {
      if (item?.status === 200) {
        toast.success(item?.message || "added successfully", {
          duration: 8000,
          position: "top-right",
        });
        // navigate(wa.INVENTORY_STOCK_LIST);
      } else {
        toast.error(item?.message || "Please try again !!", {
          duration: 4000,
          position: "top-right",
        });
      }
      // setDisabled(false);
    });
  };

  let serviceColInfo = [
    {
      name: "Service Line Nr",
      cell: (row) => <span>{row.serviceLineNr} </span>,
      width: "180px",
    },
    {
      name: "Service Number",
      cell: (row) => <span>{row.serviceNr} </span>,
      width: "180px",
    },
    {
      name: "Service Desc",
      cell: (row) => <span>{row.serviceDescription} </span>,
      width: "180px",
    },
    {
      name: "UOM",
      cell: (row) => <span>{row.orderUnitOfMeasure} </span>,
      width: "180px",
    },
    {
      name: "Service Quantity",
      cell: (row) => <span>{row.serviceQuantity} </span>,
      width: "180px",
    },
    {
      name: "Unit Value",
      cell: (row) => <span>{row.unitValue} </span>,
      width: "180px",
    },
    {
      name: "Gross Value",
      cell: (row) => <span>{row.grossValue} </span>,
      width: "180px",
    },
    {
      name: "Delivery Date",
      cell: (row) => <span>{row.deliveryDate} </span>,
      width: "180px",
    },
  ];
  //ScheduleItems
  let scheduleColInfo = [
    {
      name: "Schedule LineNr",
      cell: (row) => <span>{row.scheduleLineNr} </span>,
      width: "180px",
    },
    {
      name: "Day/Week/Month",
      cell: (row) => <span>{row.schedulePeriod} </span>,
      width: "180px",
    },
    {
      name: "Schedule From",
      cell: (row) => <span>{row.scheduleFromDate} </span>,
      width: "180px",
    },
    {
      name: "Schedule To",
      cell: (row) => <span>{row.scheduleToDate} </span>,
      width: "180px",
    },
    {
      name: "Schedule Quantity",
      cell: (row) => <span>{row.scheduleQuantity} </span>,
      width: "180px",
    },
    {
      name: " Reservation No",
      cell: (row) => <span>{row.reservationNr} </span>,
      width: "180px",
    },
    {
      name: "Delivery Date",
      cell: (row) => <span>{row.deliveryDate} </span>,
      width: "180px",
    },
  ];
  const [getItemNr, setItemNr] = useState("");
  const [getServiceData, setServiceData] = useState([]);
  const [getServiceTableStatus, setServiceTableStatus] = useState(false);

  useEffect(() => {
    if (divRef.current) {
      try {
        // eslint-disable-next-line no-unused-vars
        const styles = window.getComputedStyle(divRef.current);
      } catch (error) {
        console.error("Failed to get computed style:", error);
      }
    }
  }, [getServiceTableStatus]);

  const [itemLevelModalShow, setItemLevelModalShow] = useState(false);
  // OnClick on lineItem  Data
  const lineItemShowModal = (itemLevelData) => {
    setItemLevelData(itemLevelData);
    setItemLevelColumns(lineItemColInfo);
    setModalTitle("Item Text Details");
    setItemLevelModalShow(true);
  };
  const itemLevelHideModal = () => {
    setItemLevelModalShow(false);
  };

  // OnClick on Header Text  Data
  const headerTextShowModal = (headerTextData) => {
    setItemLevelData(headerTextData);
    setItemLevelColumns(lineItemColInfo);
    setModalTitle("Header Text Details");
    setViewHeaderText(true);
  };
  const headerTextHideModal = () => {
    setViewHeaderText(false);
  };

  //--------------- Start Items Pop for history tables  -----------------------------------------------------

  // ASN Items
  let ASNLineItemColInfo = [
    {
      name: "Item Number",
      cell: (row) => <span>{row.purchasingDocumentItemNr} </span>,
      width: "180px",
    },
    {
      name: "Material",
      cell: (row) => <span>{row.materialCode} </span>,
      width: "180px",
    },
    {
      name: "Material Desc",
      cell: (row) => <span>{row.materialDescription} </span>,
      width: "220px",
    },
    {
      name: "Material Group",
      cell: (row) => <span>{row.materialClass2} </span>,
      width: "220px",
    },
    {
      name: "Quantity",
      cell: (row) => <span>{row.purchaseQuantity} </span>,
      width: "220px",
    },
    {
      name: "Price Unit",
      cell: (row) => <span>{row.orderPriceUnit} </span>,
      width: "220px",
    },
  ];

  const [getASNitemLevelModalShow, setASNitemLevelModalShow] = useState(false);
  // OnClick on lineItem  Data
  const ASNLineItemShowModal = (itemLevelData) => {
    setItemLevelData(itemLevelData);
    setItemLevelColumns(ASNLineItemColInfo);
    setModalTitle("ASN Line Item Details");
    setASNitemLevelModalShow(true);
  };
  const ASNItemLevelHideModal = () => {
    setASNitemLevelModalShow(false);
  };

  // GRN Items
  let GRNLineItemColInfo = [
    {
      name: "Item Number",
      cell: (row) => <span>{row.purchasingDocumentItemNr} </span>,
      width: "180px",
    },
    {
      name: "Material",
      cell: (row) => <span>{row.materialCode} </span>,
      width: "180px",
    },
    {
      name: "Material Desc",
      cell: (row) => <span>{row.materialDescription} </span>,
      width: "220px",
    },
    {
      name: "Material Group",
      cell: (row) => <span>{row.materialClass2} </span>,
      width: "220px",
    },
    {
      name: "Quantity",
      cell: (row) => <span>{row.purchaseQuantity} </span>,
      width: "220px",
    },
    {
      name: "Price Unit",
      cell: (row) => <span>{row.orderPriceUnit} </span>,
      width: "220px",
    },
  ];

  const [getGRNitemLevelModalShow, setGRNitemLevelModalShow] = useState(false);
  // OnClick on lineItem  Data
  const GRNLineItemShowModal = (itemLevelData) => {
    setItemLevelData(itemLevelData);
    setItemLevelColumns(GRNLineItemColInfo);
    setModalTitle("GRN Line Item Details");
    setGRNitemLevelModalShow(true);
  };
  const GRNLItemLevelHideModal = () => {
    setGRNitemLevelModalShow(false);
  };

  // Invoice Items
  let InvoiceLineItemColInfo = [
    {
      name: "Item Number",
      cell: (row) => <span>{row.invoiceItemNr} </span>,
      width: "180px",
    },
    {
      name: "Material",
      cell: (row) => <span>{row.materialCode} </span>,
      width: "180px",
    },
    {
      name: "Material Desc",
      cell: (row) => <span>{row.materialDescription} </span>,
      width: "220px",
    },
    {
      name: "UOM",
      cell: (row) => <span>{row.orderUnitOfMeasure} </span>,
      width: "220px",
    },
    {
      name: "Quantity",
      cell: (row) => <span>{row.invoiceQuantity} </span>,
      width: "220px",
    },
    {
      name: "Price Unit",
      cell: (row) => <span>{row.orderPriceUnit} </span>,
      width: "220px",
    },
    {
      name: "Total Price",
      cell: (row) => <span>{row.totalPrice} </span>,
      width: "220px",
    },
    {
      name: "Tax %",
      cell: (row) => <span>{row.taxCode} </span>,
      width: "220px",
    },
    {
      name: "Total Tax",
      cell: (row) => <span>{row.totalTax} </span>,
      width: "220px",
    },
  ];
  const [getInvoiceitemLevelModalShow, setInvoiceitemLevelModalShow] =
    useState(false);
  // OnClick on lineItem  Data
  const InvoiceLineItemShowModal = (itemLevelData) => {
    setItemLevelData(itemLevelData);
    setItemLevelColumns(InvoiceLineItemColInfo);
    setModalTitle("Invoice Line Item Details");
    setInvoiceitemLevelModalShow(true);
  };
  const InvoiceItemLevelHideModal = () => {
    setInvoiceitemLevelModalShow(false);
  };

  // SES Items
  let SESLineItemColInfo = [
    {
      name: "Item Number",
      cell: (row) => <span>{row.purchasingDocumentItemNr} </span>,
      width: "180px",
    },
    {
      name: "Material",
      cell: (row) => <span>{row.materialCode} </span>,
      width: "180px",
    },
    {
      name: "Material Desc",
      cell: (row) => <span>{row.materialDescription} </span>,
      width: "220px",
    },
    {
      name: "Material Group",
      cell: (row) => <span>{row.materialClass2} </span>,
      width: "220px",
    },
    {
      name: "Quantity",
      cell: (row) => <span>{row.purchaseQuantity} </span>,
      width: "220px",
    },
    {
      name: "Price Unit",
      cell: (row) => <span>{row.orderPriceUnit} </span>,
      width: "220px",
    },
  ];

  const [getSESitemLevelModalShow, setSESitemLevelModalShow] = useState(false);
  // OnClick on lineItem  Data
  const SESLineItemShowModal = (itemLevelData) => {
    setItemLevelData(itemLevelData);
    setItemLevelColumns(SESLineItemColInfo);
    setModalTitle("SES Line Item Details");
    setSESitemLevelModalShow(true);
  };
  const SESLItemLevelHideModal = () => {
    setSESitemLevelModalShow(false);
  };

  // Three ModelGoodsMovement Item Cols
  let threeGoodsMovementCols = [
    {
      name: "PO Item Nr",
      cell: (row) => (
        <span className="bg-table-status bg-table-new-status w-50">
          {row.purchasingDocumentItemNr}
        </span>
      ),
      width: "130px",
    },
    {
      name: "GRN Nr",
      cell: (row) => (
        <span className="bg-table-status bg-table-new-status w-50">
          {row.grnNr}
        </span>
      ),
      width: "180px",
    },
    {
      name: "GRN Item Nr",
      cell: (row) => <span>{row.grnItemNr} </span>,
      width: "120px",
    },
    {
      name: "Material",
      cell: (row) => (
        <div>
          <p className="p-0 m-0 fw-bold">{row.materialCode} </p>
          <p className="p-0 m-0">{row.materialDescription} </p>
        </div>
      ),
      width: "100px",
    },
    {
      name: "PO Qty",
      cell: (row) => <span>{row.purchaseQuantity || "--"} </span>,
      width: "100px",
    },

    {
      name: "GRN Qty",

      cell: (row) => (
        <div>
          <p className="p-0 m-0 fw-bold text-primary">{row.grnQuantity} </p>
          <p className="p-0 m-0 text-primary">{row.orderUnitOfMeasure} </p>
        </div>
      ),
      width: "100px",
    },
    {
      name: "Total Price",
      cell: (row) => <span>{row.totalPrice || "--"} </span>,
      width: "100px",
    },
  ];

  let threeInvoiceRegisterCols = [
    {
      name: "PO Item Nr",
      cell: (row) => (
        <span className="bg-table-status bg-table-new-status w-50">
          {row.purchasingDocumentItemNr}
        </span>
      ),
      width: "180px",
    },
    {
      name: "INV Nr",
      cell: (row) => (
        <span className="bg-table-status bg-table-success-status w-50">
          {row.invoiceNr}
        </span>
      ),
      width: "180px",
    },
    {
      name: "INV Item Nr",
      cell: (row) => <span>{row.invoiceItemNr} </span>,
      width: "180px",
    },
    {
      name: "Material",
      cell: (row) => (
        <div>
          <p className="p-0 m-0 fw-bold">{row.materialCode} </p>
          <p className="p-0 m-0">{row.materialDescription} </p>
        </div>
      ),
      width: "220px",
    },
    {
      name: "PO Qty",
      cell: (row) => <span>{row.purchaseQuantity || "--"} </span>,
      width: "220px",
    },
    {
      name: "GRN Qty",
      cell: (row) => (
        <div>
          <p className="p-0 m-0 fw-bold text-primary">{row.grnQuantity} </p>
          <p className="p-0 m-0 text-primary">{row.orderUnitOfMeasure} </p>
        </div>
      ),
      width: "220px",
    },
    {
      name: "INV Qty",
      cell: (row) => (
        <div>
          <p className="p-0 m-0 fw-bold text-success">{row.invoiceQuantity} </p>
          <p className="p-0 m-0 text-success">{row.orderUnitOfMeasure} </p>
        </div>
      ),
      width: "100px",
    },
    // {
    //   name: "OrderUnit Of Measure",
    //    cell: (row) => (
    //     <div>
    //       <p className="p-0 m-0 fw-bold">{row.orderUnitOfMeasure || "--"} </p>
    //     </div>
    //   ),
    //   width: "220px",
    // },
    {
      name: "Order Price Unit",
      cell: (row) => <span>{row.orderPriceUnit} </span>,
      width: "220px",
    },
    {
      name: "Basic Value",
      cell: (row) => (
        <span className="fw-bold text-success">{row.totalPrice} </span>
      ),
      width: "220px",
    },
    {
      name: "Tax",
      cell: (row) => (
        <div>
          <p className="p-0 m-0 fw-bold text-success">
            {(parseFloat(row.totalPrice) / 100) * parseFloat(row.taxCode)}{" "}
          </p>
          {/* <p className="p-0 m-0 fw-bold">{row.taxAmount } </p> */}
          <p className="p-0 m-0 ">{row.taxCode}% </p>
        </div>
      ),
      width: "220px",
    },
    // {
    //   name: "INV Item Tax Value",
    //   cell: (row) => <span>{row.invItemTaxValue} </span>,
    //   width: "220px",
    // },
    {
      name: "Total Value",
      cell: (row) => (
        <div>
          <p className="p-0 m-0 fw-bold text-success">
            {(parseFloat(row.totalPrice) / 100) * parseFloat(row.taxCode) +
              parseFloat(row.totalPrice)}{" "}
          </p>
        </div>
      ),
      width: "220px",
    },
  ];

  const [getThreeTwoModalShow, setThreeTwoModalShow] = useState(false);
  // OnClick on lineItem  Data
  const threeTwoItemShowModal = (itemLevelData, titleName, modalItemCols) => {
    setItemLevelData(itemLevelData);
    setItemLevelColumns(modalItemCols);
    setModalTitle(titleName);
    setThreeTwoModalShow(true);
  };
  const threeTwoItemHideModal = () => {
    setThreeTwoModalShow(false);
  };

  //---------------  END Items Pop for history tables   -----------------------------------------------------

  const toggleCardVisibility = () => {
    setCardVisible(!isCardVisible);
  };
  const toggleCardVisibility2 = () => {
    setCardVisible2(!isCardVisible2);
  };
  const toggleCardVisibility3 = () => {
    setCardVisible3(!isCardVisible3);
  };
  const toggleCardVisibility4 = () => {
    setCardVisible4(!isCardVisible4);
  };

  const toggleCardVisibility5 = () => {
    setCardVisible5(!isCardVisible5);
  };
  const toggleCardVisibility6 = () => {
    setCardVisible6(!isCardVisible6);
  };

  const loadInitialPageData = async () => {
    setLoading(true);
    if (poNumber) {
      let obj = {
        documentNumber: poNumber,
      };
      const toastId = toast.loading("Loading...", {
        position: "top-right",
      });
      await ItemServiceV1.getPurchaseOrderDetailWH(obj).then((item) => {
        if (item?.status === 200) {
          setHeaderData(item?.data);
          setData(item?.data?.items);
          dispatch(addPoSelectedDetails(item?.data));
        } else {
          toast.error(item?.message || "Please try again !!", {
            duration: 4000,
            position: "top-right",
          });
        }
        toast.dismiss(toastId);
      });

      setLoading(false);
    } else {
      window.history.back();
    }
  };

  //load Two Way Match Data
  // eslint-disable-next-line no-unused-vars
  const loadTwoWayMatchData = async () => {
    let obj = {
      queryName: "2_WAY_MATCHING_BY_PO",
      page: 1,
      per_page: 10,
      purchasingDocumentNr: poNumber,
    };
    await ItemService.generateQuery(obj).then((item) => {
      // console.log(">> res!", item);
      if (item?.status === 200) {
        setTwoWayMatch(item.data);
      } else {
        toast.error(item?.message || "Please try again !!", {
          duration: 4000,
          position: "top-right",
        });
      }
    });
  };

  //load Three Way Match Data
  const loadThreeWayMatchData = async () => {
    let obj = {
      queryName: "3_WAY_MATCHING_BY_PO",
      page: 1,
      per_page: 10,
      purchasingDocumentNr: poNumber,
    };
    await ItemService.generateQuery(obj).then((item) => {
      // console.log(">> res!", item);
      if (item?.status === 200) {
        setThreeWayMatch(item.data);
      } else {
        toast.error(item?.message || "Please try again !!", {
          duration: 4000,
          position: "top-right",
        });
      }
    });
  };

  useEffect(() => {
    loadInitialPageData(); // fetch page 1 of users
    loadGrnHistoricalData(); // Load GRN History Data
    loadAsnHistoricalData(); // Load ASN History Data
    loadInvoiceHistoricalData(); // Load Invoice History Data
    loadSesHistoricalData(); // Load SES History Data

    // loadTwoWayMatchData(); // Load Two way matching Data // Not required
    loadThreeWayMatchData(); // Load Three way matching Data
    dispatch(addSelectedItemList([]));
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [poNumber, purchase_order_data]);

  const detailedPageGRN = (grnNumber) => {
    dispatch(addGRNDetailNumber(grnNumber));
    navigate(Constants.POCOLLABRATION_GRN_DETAILS);
  };

  const detailedPageASN = (ansNumber) => {
    dispatch(addASNDetailNumber(ansNumber));
    navigate(Constants.POCOLLABRATION_ASN_DETAIL_PAGE);
  };

  const detailedPageInvoice = (ansNumber) => {
    dispatch(addInvoiceDetailNumber(ansNumber));
    navigate(Constants.POCOLLABRATION_INVOICE_DETIAILS);
  };

  const detailedPageSES = (sesNumber) => {
    dispatch(addSesDetailNumber(sesNumber));
    navigate(Constants.POCOLLABRATION_SERVICE_ENTRY_DETAILS);
  };

  const POLineItemInitialCol = [
    {
      name: "Document Item Nr",
      selector: (row) => row.purchasingDocumentItemNr || row.localid || "--",
      width: "180px",
    },
    {
      name: "PO Number",
      selector: () => poNumber || "--",
      sortable: true,
      width: "150px",
    },
    {
      name: "PO Item Nr",
      selector: (row) =>
        row.purchasingDocumentItemNr != null
          ? row.purchasingDocumentItemNr
          : (row.purchasingReqDocumentItemNr ?? "--"),
      sortable: true,
      width: "150px",
    },
    {
      name: "Status",
      cell: (row) => (
        <TableStatusField status={row.statusItem || "In Release"} />
      ),
      width: "180px",
    },
    // {
    //   name: "Material/Service",
    //   selector: (row) => row.materialCode || "--",
    //   cell: (row) =>
    //     row.isNew ? (
    //       <InputField
    //         className="inputBox mt-1"
    //         name="materialCode"
    //         value={row.materialCode || ""}
    //         onChange={(event) => handleInputChange(row.localid, event)}
    //       />
    //     ) : (
    //       <div>
    //         <p className="m-0 p-0 pt-1 fw-bold">{row.materialCode || "--"}</p>
    //         <p className="m-0 p-0">{row.materialDescription || "--"}</p>
    //       </div>
    //     ),
    //   width: "200px",
    // },
    {
      name: "Material/Service",
      cell: (row) => {
        if (row.isNew) {
          return (
            <InputField
              className="inputBox mt-1"
              name="materialCode"
              value={row.materialCode || ""}
              onChange={(event) => handleInputChange(row.localid, event)}
            />
          );
        }

        if (isEditMode) {
          const itemNr = row.purchasingDocumentItemNr;

          return (
            <InputField
              className="inputBox mt-1"
              value={
                editedItems[itemNr]?.materialCode ?? row.materialCode ?? ""
              }
              onChange={(event) =>
                handleItemFieldChange(
                  itemNr,
                  "materialCode",
                  event.target.value,
                  row,
                )
              }
            />
          );
        }

        return (
          <div>
            <p className="m-0 p-0 pt-1 fw-bold">{row.materialCode || "--"}</p>
            <p className="m-0 p-0">{row.materialDescription || "--"}</p>
          </div>
        );
      },
    },
    {
      name: "Description",
      selector: (row) => row.materialDescription || "--",
      cell: (row) =>
        row.isNew ? (
          <TextAreaField
            className="inputBox mt-1"
            name="materialDescription"
            value={row.materialDescription || ""}
            onChange={(event) => handleInputChange(row.localid, event)}
          />
        ) : (
          <span>{row.materialDescription || "--"}</span>
        ),
      width: "200px",
    },
    {
      name: "Quantity",
      cell: (row) => {
        if (row.isNew) {
          return (
            <InputField
              className="inputBox mt-1"
              name="purchaseQuantity"
              value={row.purchaseQuantity || ""}
              onChange={(event) =>
                handleInputChange(row.localid, event, "Number")
              }
            />
          );
        }

        if (isEditMode) {
          const itemNr = row.purchasingDocumentItemNr;
          return (
            <InputField
              className="inputBox mt-1"
              name="purchaseQuantity"
              value={
                editedItems[itemNr]?.purchaseQuantity ??
                row.purchaseQuantity ??
                ""
              }
              onChange={(event) =>
                handleItemFieldChange(
                  itemNr,
                  "purchaseQuantity",
                  event.target.value,
                  row,
                )
              }
            />
          );
        }

        return <span>{row.purchaseQuantity || "--"}</span>;
      },
      width: "180px",
    },
    {
      name: "Unit Price",
      cell: (row) => {
        if (row.isNew) {
          return (
            <InputField
              className="inputBox mt-1"
              name="orderPriceUnit"
              value={row.orderPriceUnit || ""}
              onChange={(event) =>
                handleInputChange(row.localid, event, "Number")
              }
            />
          );
        }

        if (isEditMode) {
          const itemNr = row.purchasingDocumentItemNr;
          return (
            <InputField
              className="inputBox mt-1"
              name="orderPriceUnit"
              value={
                editedItems[itemNr]?.orderPriceUnit ?? row.orderPriceUnit ?? ""
              }
              onChange={(event) =>
                handleItemFieldChange(
                  itemNr,
                  "orderPriceUnit",
                  event.target.value,
                  row,
                )
              }
            />
          );
        }

        return <span>{row.orderPriceUnit || "--"}</span>;
      },
      width: "180px",
    },
    {
      name: "Item Value",
      cell: (row) => {
        if (row.isNew) {
          return (
            <InputField
              className="inputBox mt-1"
              name="netValue"
              value={row.netValue || 0}
              disabled
            />
          );
        }

        const itemNr = row.purchasingDocumentItemNr;
        return (
          <span className="fw-bold">
            {isEditMode
              ? (editedItems[itemNr]?.netValue ?? row.netValue ?? 0)
              : (row.netValue ?? 0)}
          </span>
        );
      },
      width: "180px",
    },
    {
      name: "Tax Code ",
      selector: (row) => row.taxCode || "--",
      cell: (row) => {
        if (row.isNew) {
          return (
            <InputField
              className="inputBox mt-1"
              name="taxCode"
              placeholder=""
              value={row.taxCode}
              onChange={(event) =>
                handleInputChange(row.localid, event, "Number")
              }
            />
          );
        }

        if (isEditMode) {
          const itemNr = row.purchasingDocumentItemNr;
          return (
            <InputField
              className="inputBox mt-1"
              name="taxCode"
              placeholder=""
              value={editedItems[itemNr]?.taxCode ?? row.taxCode ?? ""}
              onChange={(event) =>
                handleItemFieldChange(
                  itemNr,
                  "taxCode",
                  event.target.value,
                  row,
                )
              }
            />
          );
        }

        return <span>{row.taxCode ?? "--"}</span>;
      },
      sortable: true,
      width: "200px",
    },
    {
      name: "Delivery Date",
      selector: (row) => row.deliveryDate || "--",
      cell: (row) =>
        row.isNew ? (
          <InputField
            className="inputBox mt-1"
            type="date"
            name="deliveryDate"
            value={row.deliveryDate || ""}
            onChange={(event) => handleInputChange(row.localid, event)}
          />
        ) : (
          <span>{row.deliveryDate || "--"}</span>
        ),
      width: "200px",
    },
    {
      name: "Plant",
      selector: (row) => row.plant || "--",
      cell: (row) =>
        row.isNew ? (
          <InputField
            className="inputBox mt-1"
            name="plant"
            value={row.plant || ""}
            onChange={(event) => handleInputChange(row.localid, event)}
          />
        ) : (
          <span>{row.plant || "--"}</span>
        ),
      sortable: true,
      width: "200px",
    },
    {
      name: "Storage Location",
      selector: (row) => row.storageLocn || "--",
      cell: (row) =>
        row.isNew ? (
          <InputField
            className="inputBox mt-1"
            name="storageLocn"
            value={row.storageLocn || ""}
            onChange={(event) => handleInputChange(row.localid, event)}
          />
        ) : (
          <span>{row.storageLocn || "--"}</span>
        ),
      sortable: true,
      width: "200px",
    },
    // {
    //   name: "Delete",
    //   selector: (row) => row.localid || "--",
    //   sortable: true,
    //   cell: (row) =>
    //     row.isNew ? (
    //       <button
    //         className="btn btn-danger"
    //         onClick={() => removePOItemRow(row.localid)}
    //       >
    //         <i className="bi bi-trash3"></i>
    //       </button>
    //     ) : null,
    //   width: "120px",
    // },
  ];
  // const removePOItemRow = (rowId) => {
  //   setPOLineItemsData((prev) => prev.filter((row) => row.local_id !== rowId));
  // };
  const columnsService = [
    {
      name: "PO Number",
      selector: (row) => poNumber,
      sortable: true,
      width: "150px",
    },
    {
      name: "PO Item Nr",
      selector: (row) => row.purchasingDocumentItemNr,
      sortable: true,
      width: "150px",
    },
    {
      name: "Status",
      cell: (row) => (
        <>
          <TableStatusField status={row.statusItem} />
        </>
      ),
      width: "160px",
    },
    {
      name: "Material/Service",
      selector: (row) => row.materialCode,
      sortable: true,
      width: "150px",
      cell: (row) => (
        <div>
          <p className="m-0 p-0 fw-bold text-primary">
            {row.materialDescription}{" "}
          </p>
          <p className="m-0 p-0 pt-1 ">{row.materialCode} </p>
        </div>
      ),
    },
    {
      name: "Item Text",
      cell: (row) => (
        <>
          <span
            style={{ marginLeft: "12px" }}
            onClick={() => lineItemShowModal(row.itemTextData)}
          >
            <i className="bi bi-calendar2-week iconTable"></i>
          </span>
          <span className="suppliersIcon">
            {" "}
            {row.itemTextData?.length || 0}{" "}
          </span>
        </>
      ),
      width: "100px",
    },
    {
      name: "Service",
      cell: (row) => (
        <>
          <span
            style={{ marginLeft: "12px" }}
            onClick={() =>
              showServiceItemTable(row.services, row.purchasingDocumentItemNr)
            }
          >
            <i className="bi bi-calendar2-week iconTable"></i>
          </span>
          <span className="suppliersIcon"> {row.services?.length || 0} </span>
        </>
      ),
      width: "180px",
    },
    {
      name: "Purchase Quantity",
      selector: (row) => row.purchaseQuantity,
      sortable: true,
      width: "180px",
    },
    {
      name: "Order Unit",
      selector: (row) => row.orderUnitOfMeasure,
      sortable: true,
      width: "120px",
    },
    {
      name: "Unit Price",
      selector: (row) => row.orderPriceUnit,
      sortable: true,
      width: "120px",
    },
    {
      name: "Item Value",
      // selector: (row) => row.netValue,
      cell: (row) => (
        <span className="numberFormate m-0 p-0 pt-1 fw-bold">
          {currencyFormat(Number(row.netValue).toFixed(2))}
        </span>
      ),

      sortable: true,
      width: "180px",
    },
    {
      name: "Currency",
      selector: (row) => row.currencyCode,
      sortable: true,
      width: "120px",
    },
    {
      name: "Delivery Date",
      selector: (row) => row.deliveryDate,
      sortable: true,
      width: "140px",
    },
    {
      name: "Tax Amount",
      selector: (row) => row.taxAmount,
      sortable: true,
      width: "200px",
    },
    // {
    //   name: "Price Unit Qty",
    //   selector: (row) => row.priceUnit,
    //   sortable: true,
    //   width: "200px",
    // },
    {
      name: "Tax Code",
      selector: (row) => row.taxId,
      sortable: true,
      width: "200px",
    },
    {
      name: "Tax Desc",
      selector: (row) => row.taxIdDesc,
      sortable: true,
      width: "200px",
    },
    {
      name: "Free Of Cost",
      selector: (row) => row.freeCost,
      sortable: true,
      width: "200px",
    },
    {
      name: "Purch Req Nr",
      selector: (row) => row.requestNumber,
      sortable: true,
      width: "200px",
    },
    {
      name: "PR Item Nr",
      selector: (row) => row.prItemNr,
      sortable: true,
      width: "200px",
    },
    {
      name: "ExcessTolerance",
      selector: (row) => row.excessTolerance,
      sortable: true,
      width: "200px",
    },
    {
      name: "ShortageTolerance",
      selector: (row) => row.shortageTolerance,
      sortable: true,
      width: "200px",
    },
  ];

  const columnsSchedule = [
    {
      name: "PO Number",
      selector: (row) => poNumber,
      sortable: true,
      width: "150px",
    },
    {
      name: "PO Item Nr",
      selector: (row) => row.purchasingDocumentItemNr,
      sortable: true,
      width: "150px",
    },
    {
      name: "Status",
      cell: (row) => (
        <>
          <TableStatusField status={row.statusItem} />
        </>
      ),
      width: "160px",
    },
    {
      name: "Material/Service",
      selector: (row) => row.materialCode,
      sortable: true,
      width: "150px",
      cell: (row) => (
        <div>
          <p className="m-0 p-0 pt-1 fw-bold">{row.materialCode} </p>
          <p className="m-0 p-0">{row.materialDescription} </p>
        </div>
      ),
    },
    {
      name: "Item Text",
      cell: (row) => (
        <>
          <span
            style={{ marginLeft: "12px" }}
            onClick={() => lineItemShowModal(row.itemTextData)}
          >
            <i className="bi bi-calendar2-week iconTable"></i>
          </span>
          <span className="suppliersIcon">
            {" "}
            {row.itemTextData?.length || 0}{" "}
          </span>
        </>
      ),
      width: "100px",
    },
    {
      name: "Schedules",
      cell: (row) => (
        <>
          <span
            style={{ marginLeft: "12px" }}
            onClick={() =>
              showServiceItemTable(row.schedule, row.purchasingDocumentItemNr)
            }
          >
            <i className="bi bi-calendar2-week iconTable"></i>
          </span>
          <span className="suppliersIcon"> {row.schedule?.length || 0} </span>
        </>
      ),
      width: "180px",
    },
    {
      name: "Purchase Quantity",
      selector: (row) => row.purchaseQuantity,
      sortable: true,
      width: "180px",
    },
    {
      name: "Oder Unit",
      selector: (row) => row.orderUnitOfMeasure,
      sortable: true,
      width: "120px",
    },
    {
      name: "Unit Price",
      selector: (row) => row.orderPriceUnit,
      sortable: true,
      width: "120px",
    },
    {
      name: "Item Value",
      // selector: (row) => row.netValue,
      cell: (row) => (
        <span className="numberFormate">
          {currencyFormat(Number(row.netValue).toFixed(2))}
        </span>
      ),

      sortable: true,
      width: "180px",
    },
    {
      name: "Currency",
      selector: (row) => row.currencyCode,
      sortable: true,
      width: "120px",
    },
    {
      name: "Delivery Date",
      selector: (row) => row.deliveryDate,
      sortable: true,
      width: "140px",
    },
    {
      name: "Tax Amount",
      selector: (row) => row.taxAmount,
      sortable: true,
      width: "200px",
    },
    // {
    //   name: "Price Unit Qty",
    //   selector: (row) => row.priceUnit,
    //   sortable: true,
    //   width: "200px",
    // },
    {
      name: "Tax Code",
      selector: (row) => row.taxId,
      sortable: true,
      width: "200px",
    },
    {
      name: "Tax Desc",
      selector: (row) => row.taxIdDesc,
      sortable: true,
      width: "200px",
    },
    {
      name: "Free Of Cost",
      selector: (row) => row.freeCost,
      sortable: true,
      width: "200px",
    },
    {
      name: "Purch Req Nr",
      selector: (row) => row.requestNumber,
      sortable: true,
      width: "200px",
    },
    {
      name: "PR Item Nr",
      selector: (row) => row.prItemNr,
      sortable: true,
      width: "200px",
    },
    {
      name: "ExcessTolerance",
      selector: (row) => row.excessTolerance,
      sortable: true,
      width: "200px",
    },
    {
      name: "ShortageTolerance",
      selector: (row) => row.shortageTolerance,
      sortable: true,
      width: "200px",
    },
  ];

  // PO items columns Details
  const lineItemColInfo = [
    {
      name: "Code",
      cell: (row) => <span>{row.documentId} </span>,
      width: "200px",
    },
    {
      name: "Text",
      cell: (row) => <span>{row.documentText} </span>,
      width: "250px",
    },
  ];

  //GRN Historical Table
  const grnHistoryColInfo = [
    {
      name: "GRN Number",
      selector: (row) => row.grnNr,
      cell: (row) => (
        <button className="btnInfo" onClick={() => detailedPageGRN(row.grnNr)}>
          {row.grnNr}{" "}
        </button>
      ),
      sortable: true,
      width: "150px",
    },
    {
      name: "Collaboration",
      cell: (row) => (
        <>
          <span>
            <i className="bi bi-git iconTable"></i>
          </span>
          <span>
            <i className="bi bi-collection-play iconTable"></i>
          </span>
          <span>
            <i className="bi bi-stack iconTable"></i>
          </span>
        </>
      ),
      width: "150px",
    },
    {
      name: "Status",
      selector: (row) => row.grnStatusHeader,
      cell: (row) => (
        <>
          <TableStatusField status={row.grnStatusHeader} />
        </>
      ),
      sortable: true,
      width: "160px",
    },
    {
      name: "GRN Date",
      selector: (row) => row.shippmentDate || "--",
      sortable: true,
      width: "150px",
    },
    {
      name: "Line Items",
      cell: (row) => (
        <>
          <span
            style={{ marginLeft: "12px" }}
            onClick={() => GRNLineItemShowModal(row.items)}
          >
            <i className="bi bi-calendar2-week iconTable"></i>
          </span>
          <span className="suppliersIcon"> {row.items?.length} </span>
        </>
      ),
      width: "120px",
    },
    {
      name: "Vendor",
      selector: (row) => row.vendorCode,
      sortable: true,
      width: "150px",
      cell: (row) => (
        <div>
          <p className="m-0 p-0 pt-1 fw-bold">{row.vendorCode} </p>
          <p className="m-0 p-0">{row.vendorName} </p>
        </div>
      ),
    },
    {
      name: "SAP IBD ",
      selector: (row) => row.sapInboundDelivery || "--",
      sortable: true,
      width: "180px",
    },
    {
      name: "SAP GRN",
      selector: (row) => row.grnNumber || "--",
      sortable: true,
      width: "180px",
    },
    {
      name: "Posted On",
      selector: (row) => row.postedOn || "--",
      sortable: true,
      width: "150px",
    },
    {
      name: "GRN Value",
      selector: (row) => row.sumOfGrn || "--",
      cell: (row) => (
        <>
          <div>
            <p className="m-0 p-0 fw-bold">{row.sumOfGrn}</p>
            <p className="m-0 p-0">{row.currencyCode}</p>
          </div>
        </>
      ),
      sortable: true,
      width: "150px",
    },
    // {
    //   name: "Currency",
    //   selector: (row) => row.currencyCode || "--",

    //   width: "150px",
    // },
    // {
    //   name: "Purchase Order",
    //   selector: (row) => row.items[0]?.purchasingDocumentNr || "--",
    //   sortable: true,
    //   width: "150px",
    // },
    {
      name: "Delivery Note",
      selector: (row) => row.deliveryNoteNo || "--",
      sortable: true,
      width: "140px",
    },

    {
      name: "Bill of Lading",
      selector: (row) => row.billOfLading || "--",
      sortable: true,
      width: "150px",
    },
    {
      name: "Cancelled GRN Nr",
      selector: (row) => row.purchasingDocumentItemNr,
      sortable: true,
      width: "180px",
    },
    {
      name: "Cancelled GRN Date",
      selector: (row) => row.purchasingDocumentItemNr,
      sortable: true,
      width: "180px",
    },
    {
      name: "Cancelled GRN Remark",
      selector: (row) => row.purchasingDocumentItemNr,
      sortable: true,
      width: "200px",
    },
  ];

  // ASN Historical Table
  const asnHistoryColInfo = [
    {
      name: "ASN Number",
      selector: (row) => row.asnNumber,
      cell: (row) => (
        <button
          className="btnInfo"
          onClick={() => detailedPageASN(row.asnNumber)}
        >
          {row.asnNumber}{" "}
        </button>
      ),
      sortable: true,
      width: "150px",
    },
    {
      name: "Collaboration",
      cell: (row) => (
        <>
          <span>
            <i className="bi bi-git iconTable"></i>
          </span>
          <span>
            <i className="bi bi-collection-play iconTable"></i>
          </span>
          <span>
            <i className="bi bi-stack iconTable"></i>
          </span>
        </>
      ),
      width: "150px",
    },
    {
      name: "Status",
      selector: (row) => row.asnStatusHeader,
      cell: (row) => (
        <>
          <TableStatusField status={row.asnStatusHeader} />
        </>
      ),
      sortable: true,
      width: "160px",
    },
    {
      name: "ASN Date",
      selector: (row) => row.asnDate || "--",
      sortable: true,
      width: "150px",
    },
    {
      name: "Line Items",
      cell: (row) => (
        <>
          <span
            style={{ marginLeft: "12px" }}
            onClick={() => ASNLineItemShowModal(row.items)}
          >
            <i className="bi bi-calendar2-week iconTable"></i>
          </span>
          <span className="suppliersIcon"> {row.items?.length} </span>
        </>
      ),
      width: "120px",
    },
    {
      name: "Vendor",
      selector: (row) => row.vendorCode,
      sortable: true,
      width: "150px",
      cell: (row) => (
        <div>
          <p className="m-0 p-0 pt-1 fw-bold">{row.vendorCode} </p>
          <p className="m-0 p-0">{row.vendorName} </p>
        </div>
      ),
    },
    {
      name: "SAP IBD ",
      selector: (row) => row.sapInboundDelivery || "--",
      sortable: true,
      width: "180px",
    },
    {
      name: "SAP GRN",
      selector: (row) => row.grnNumber || "--",
      sortable: true,
      width: "180px",
    },
    {
      name: "Posted On",
      selector: (row) => row.postedOn || "--",
      sortable: true,
      width: "150px",
    },
    {
      name: "Invoice Number",
      selector: (row) => row.vendorInvoiceNo,
      sortable: true,
      width: "180px",
    },
    {
      name: "Invoice Date",
      selector: (row) => row.vendorInvoiceDate || "--",
      sortable: true,
      width: "150px",
    },
    {
      name: "Invoice Value",
      selector: (row) => row.vendorTotalInvoiceValue || "--",
      sortable: true,
      width: "150px",
    },
    {
      name: "Currency",
      selector: (row) => row.currencyCode,
      sortable: true,
      width: "150px",
    },
    {
      name: "Shipping Type",
      cell: (row) => (
        <>
          <span> {capitalize(row.shippingType)} </span>
        </>
      ),
      width: "120px",
    },
    {
      name: "Gatepass Number",
      selector: (row) => row?.gatepassNr || "--",
      sortable: true,
      width: "150px",
    },
    {
      name: "Gatepass Date",
      selector: (row) => row?.gatepassDate || "--",
      sortable: true,
      width: "150px",
    },
    {
      name: "Gatepass Time",
      selector: (row) => row?.gatepassTime || "--",
      sortable: true,
      width: "150px",
    },
    {
      name: "Cancelled ASN Nr",
      selector: (row) => row.purchasingDocumentItemNr,
      sortable: true,
      width: "180px",
    },
    {
      name: "Cancelled ASN Date",
      selector: (row) => row.purchasingDocumentItemNr,
      sortable: true,
      width: "180px",
    },
    {
      name: "Cancelled ASN Remark",
      selector: (row) => row.purchasingDocumentItemNr,
      sortable: true,
      width: "200px",
    },
  ];

  // Invoice Historical Table
  const invoiceDataColumns = [
    {
      name: "Invoice Number",
      selector: (row) => row.invoiceNr,
      cell: (row) => (
        <button
          className="btnInfo"
          onClick={() => detailedPageInvoice(row.invoiceNr)}
        >
          {row.invoiceNr}{" "}
        </button>
      ),
      sortable: true,
      width: "160px",
    },
    {
      name: "Collaboration",
      cell: (row) => (
        <>
          <span>
            <i className="bi bi-git iconTable"></i>
          </span>
          <span>
            <i className="bi bi-collection-play iconTable"></i>
          </span>
          <span>
            <i className="bi bi-stack iconTable"></i>
          </span>
        </>
      ),
      width: "150px",
    },
    {
      name: "Status",
      selector: (row) => row.invoiceStatusHeader,
      cell: (row) => (
        <>
          <TableStatusField status={row.invoiceStatusHeader} />
        </>
      ),
      sortable: true,
      width: "180px",
    },
    // {
    //   name: "Status",
    //   cell: (row) => (
    //     <>
    //       <span className="bg-table-status bg-table-new-status">
    //         {row.invoiceStatusHeader}
    //       </span>
    //     </>
    //   ),
    //   width: "160px",
    // },
    {
      name: "Invoice Date",
      selector: (row) => row.vendorInvoiceDate,
      sortable: true,
      width: "130px",
    },
    {
      name: "Line Items",
      cell: (row) => (
        <>
          <span
            style={{ marginLeft: "12px" }}
            onClick={() => InvoiceLineItemShowModal(row.items)}
          >
            <i className="bi bi-calendar2-week iconTable"></i>
          </span>
          <span className="suppliersIcon"> {row.items?.length} </span>
        </>
      ),
      width: "120px",
    },
    {
      name: "Vendor",
      selector: (row) => row.vendorCode,
      sortable: true,
      width: "150px",
      cell: (row) => (
        <div>
          <p className="m-0 p-0 pt-1 fw-bold">{row.vendorCode} </p>
          <p className="m-0 p-0">{row.vendorName} </p>
        </div>
      ),
    },
    {
      name: "SAP Invoice",
      selector: (row) => row.sapinvoiceNr || "--",
      sortable: true,
      width: "150px",
    },
    {
      name: "Posted On",
      selector: (row) => row.sapPostedOn || "--",
      sortable: true,
      width: "130px",
    },
    {
      name: "Invoice Value",
      selector: (row) => row.vendorTotalInvoiceValue,
      cell: (row) => (
        <>
          <div>
            <p className="m-0 p-0 fw-bold">{row.vendorTotalInvoiceValue}</p>
            <p className="m-0 p-0">{row.currencyCode}</p>
          </div>
        </>
      ),
      sortable: true,
      width: "150px",
    },
    // {
    //   name: "Currency",
    //   selector: (row) => row.currencyCode,
    //   sortable: true,
    //   width: "120px",
    // },
    {
      name: "Payment Terms",
      selector: (row) => row.paymentTerms,
      sortable: true,
      width: "150px",
    },
    {
      name: "Cancelled INV Nr",
      selector: (row) => row.purchasingDocumentItemNr,
      sortable: true,
      width: "180px",
    },
    {
      name: "Cancelled INV Date",
      selector: (row) => row.purchasingDocumentItemNr,
      sortable: true,
      width: "180px",
    },
    {
      name: "Cancelled INV Remark",
      selector: (row) => row.purchasingDocumentItemNr,
      sortable: true,
      width: "200px",
    },
  ];

  //SES Historical Table
  const sesHistoryColInfo = [
    {
      name: "SES Number",
      selector: (row) => row.documentNumber,
      cell: (row) => (
        <button
          className="btnInfo"
          onClick={() => detailedPageSES(row.documentNumber)}
        >
          {row.documentNumber}{" "}
        </button>
      ),
      sortable: true,
      width: "150px",
    },
    {
      name: "Collaboration",
      cell: (row) => (
        <>
          <span>
            <i className="bi bi-git iconTable"></i>
          </span>
          <span>
            <i className="bi bi-collection-play iconTable"></i>
          </span>
          <span>
            <i className="bi bi-stack iconTable"></i>
          </span>
        </>
      ),
      width: "150px",
    },
    {
      name: "Status",
      selector: (row) => row.sesStatusHeader,
      cell: (row) => (
        <>
          <TableStatusField status={row.sesStatusHeader} />
        </>
      ),
      sortable: true,
      width: "160px",
    },
    {
      name: "SES Date",
      selector: (row) => row.createdAt || "--",
      cell: (row) => (
        <>
          <span>{formatDate(row.createdAt)}</span>
        </>
      ),
      sortable: true,
      width: "150px",
    },
    {
      name: "Line Items",
      cell: (row) => (
        <>
          <span
            style={{ marginLeft: "12px" }}
            onClick={() => SESLineItemShowModal(row.items)}
          >
            <i className="bi bi-calendar2-week iconTable"></i>
          </span>
          <span className="suppliersIcon"> {row.items?.length} </span>
        </>
      ),
      width: "120px",
    },
    {
      name: "Vendor",
      selector: (row) => row.vendorCode,
      sortable: true,
      width: "150px",
      cell: (row) => (
        <div>
          <p className="m-0 p-0 pt-1 fw-bold">{row.vendorCode} </p>
          <p className="m-0 p-0">{row.vendorName} </p>
        </div>
      ),
    },
    {
      name: "SAP IBD ",
      selector: (row) => row.sapInboundDelivery || "--",
      sortable: true,
      width: "180px",
    },
    {
      name: "SAP SES",
      selector: (row) => row.sesNumber || "--",
      sortable: true,
      width: "180px",
    },
    {
      name: "Posted On",
      selector: (row) => row.postedOn || "--",
      sortable: true,
      width: "150px",
    },
    {
      name: "SES Value",
      selector: (row) => row.sumOfSes || "--",
      sortable: true,
      width: "150px",
    },
    {
      name: "Currency",
      selector: (row) => row.currencyCode || "--",

      width: "150px",
    },
    // {
    //   name: "Purchase Order",
    //   selector: (row) => row.items[0]?.purchasingDocumentNr || "--",
    //   sortable: true,
    //   width: "150px",
    // },
    {
      name: "Delivery Note",
      selector: (row) => row.deliveryNoteNo || "--",
      sortable: true,
      width: "140px",
    },

    {
      name: "Bill of Lading",
      selector: (row) => row.billOfLading || "--",
      sortable: true,
      width: "150px",
    },
    {
      name: "Cancelled SES Nr",
      selector: (row) => row.purchasingDocumentItemNr,
      sortable: true,
      width: "180px",
    },
    {
      name: "Cancelled SES Date",
      selector: (row) => row.purchasingDocumentItemNr,
      sortable: true,
      width: "180px",
    },
    {
      name: "Cancelled SES Remark",
      selector: (row) => row.purchasingDocumentItemNr,
      sortable: true,
      width: "200px",
    },
  ];

  //Two Way Table Col
  const twoWayColInfo = [
    {
      name: "PO Number",
      selector: (row) => row.documentNumber,
      cell: (row) => (
        <button
          className="btnInfo"
          onClick={() => detailedPageSES(row.documentNumber)}
        >
          {row.documentNumber}{" "}
        </button>
      ),
      sortable: true,
      width: "150px",
    },

    {
      name: "Vendor",
      selector: (row) => row.vendorCode,
      sortable: true,
      width: "150px",
      cell: (row) => (
        <div>
          <p className="m-0 p-0 pt-1 fw-bold">{row.vendorCode} </p>
          <p className="m-0 p-0">{row.vendorName} </p>
        </div>
      ),
    },

    {
      name: "PO Item Nr",
      selector: (row) => row.purchasingDocumentItemNr,
      cell: (row) => (
        <span className="bg-table-status bg-table-new-status w-50">
          {" "}
          {row.purchasingDocumentItemNr}
        </span>
      ),
      sortable: true,
      width: "150px",
    },
    /*   {
      name: "Date",
      selector: (row) => row.createdAt || "--",
      cell: (row) => (
        <>
          <span>{formatDate(row.createdAt)}</span>
        </>
      ),
      sortable: true,
      width: "130px",
    }, */
    {
      name: "Material",
      selector: (row) => row.materialCode,
      sortable: true,
      width: "200px",
      cell: (row) => (
        <div>
          <p className="m-0 p-0 pt-1 fw-bold">{row.materialCode} </p>
          <p className="m-0 p-0">{row.materialDescription} </p>
        </div>
      ),
    },
    {
      name: "Qty",
      selector: (row) => row.purchaseQuantity,
      sortable: true,
      width: "100px",
      cell: (row) => (
        <div>
          <p className="m-0 p-0 pt-1 fw-bold">{row.purchaseQuantity} </p>
          <p className="m-0 p-0">{row.orderUnitOfMeasure} </p>
        </div>
      ),
    },

    {
      name: "Unit Price",
      selector: (row) => row.orderPriceUnit,
      sortable: true,
      width: "120px",
      cell: (row) => (
        <div>
          <p className="m-0 p-0 pt-1 fw-bold">{row.orderPriceUnit} </p>
          <p className="m-0 p-0 pt-1">{row.currencyCode} </p>
        </div>
      ),
    },

    {
      name: "Item Value",
      selector: (row) => row.netValue,
      sortable: true,
      width: "120px",
      cell: (row) => (
        <div>
          <p className="m-0 p-0 pt-1 fw-bold">{row.netValue} </p>
          <p className="m-0 p-0 pt-1">{row.currencyCode} </p>
        </div>
      ),
    },

    {
      name: "INV",
      cell: (row) => (
        <>
          <span
            style={{ marginLeft: "12px" }}
            onClick={() =>
              threeTwoItemShowModal(
                row.InvoiceRegister,
                "Invoice Register",
                threeInvoiceRegisterCols,
              )
            }
          >
            <i className="bi bi-calendar2-week iconTable"></i>
          </span>
          <span className="suppliersIcon"> {row.InvoiceRegister?.length} </span>
        </>
      ),
      width: "100px",
    },

    {
      name: "INV Qty",
      selector: (row) => row.invoiceQuantity || "--",
      cell: (row) => (
        <span className="fw-bold text-success">
          {row.invoiceQuantity || "--"}
        </span>
      ),
      width: "100px",
    },
    {
      name: "INV Total",
      selector: (row) => row.invTotalPrice || "--",
      cell: (row) => (
        <span className="fw-bold text-success">
          {row.invTotalPrice || "--"}
        </span>
      ),
      width: "100px",
    },

    {
      name: "INV Tax",
      selector: (row) => row.invItemTaxValue || "--",
      cell: (row) => (
        <span className="fw-bold text-success">
          {row.invItemTaxValue || "--"}
        </span>
      ),
      width: "100px",
    },
    {
      name: "INV Gross",
      selector: (row) => row.invItemTotalValue || "--",
      cell: (row) => (
        <span className="fw-bold text-success">
          {row.invItemTotalValue || "--"}
        </span>
      ),
      width: "100px",
    },
    {
      name: "INV Qty (Bal)",
      selector: (row) => row.invBalancePurchaseQuantity ?? "--",
      cell: (row) => (
        <span className="fw-bold text-success">
          {row.invBalancePurchaseQuantity ?? "--"}
        </span>
      ),
      width: "130px",
    },
    // {
    //   name: "Status",
    //   selector: (row) => row.statusItem,
    //   cell: (row) => (
    //     <>
    //       <TableStatusField status={row.statusItem} />
    //     </>
    //   ),
    //   sortable: true,
    //   width: "160px",
    // },
    {
      name: "Status",
      selector: (row) => row.statusItem,
      cell: (row) => {
        const purchase = parseFloat(row?.purchaseQuantity);
        // const grn = parseFloat(row?.grnQuantity);
        const invoice = parseFloat(row?.invoiceQuantity);

        const isTwoWayMatch = purchase === invoice;

        return (
          <>
            {isTwoWayMatch ? (
              <span className="bg-table-status bg-table-success-status">
                2 Way-Match
              </span>
            ) : (
              <span className="bg-table-status bg-table-danger-status">
                Mismatch
              </span> // Or leave empty: <span></span>
            )}
            {/* <TableStatusField status={row.statusItem} /> */}
          </>
        );
      },
      sortable: true,
      width: "160px",
    },
  ];

  //Three Way Table Table
  const threeWayColInfo = [
    {
      name: "PO Number",
      selector: (row) => row.documentNumber,
      cell: (row) => (
        <button
          className="btnInfo"
          onClick={() => detailedPageSES(row.documentNumber)}
        >
          {row.documentNumber}{" "}
        </button>
      ),
      sortable: true,
      width: "150px",
    },
    {
      name: "Vendor",
      selector: (row) => row.vendorCode,
      sortable: true,
      width: "150px",
      cell: (row) => (
        <div>
          <p className="m-0 p-0 pt-1 fw-bold">{row.vendorCode} </p>
          <p className="m-0 p-0">{row.vendorName} </p>
        </div>
      ),
    },

    {
      name: "PO Item Nr",
      selector: (row) => row.purchasingDocumentItemNr,
      cell: (row) => (
        <span className="bg-table-status bg-table-new-status w-50">
          {" "}
          {row.purchasingDocumentItemNr}
        </span>
      ),
      sortable: true,
      width: "150px",
    },

    {
      name: "Material",
      selector: (row) => row.materialCode,
      sortable: true,
      width: "200px",
      cell: (row) => (
        <div>
          <p className="m-0 p-0 pt-1 fw-bold">{row.materialCode} </p>
          <p className="m-0 p-0">{row.materialDescription} </p>
        </div>
      ),
    },
    {
      name: "Qty",
      selector: (row) => row.purchaseQuantity,
      sortable: true,
      width: "100px",
      cell: (row) => (
        <div>
          <p className="m-0 p-0 pt-1 fw-bold">{row.purchaseQuantity} </p>
          <p className="m-0 p-0">{row.orderUnitOfMeasure} </p>
        </div>
      ),
    },
    {
      name: "Item Value",
      selector: (row) => row.netValue,
      sortable: true,
      width: "120px",
      cell: (row) => (
        <div>
          <p className="m-0 p-0 fw-bold">{row.netValue} </p>
          <p className="m-0 p-0">{row.currencyCode} </p>
        </div>
      ),
    },

    /*  {
      name: "SES Date",
      selector: (row) => row.createdAt || "--",
      cell: (row) => (
        <>
          <span>{formatDate(row.createdAt)}</span>
        </>
      ),
      sortable: true,
      width: "150px",
    }, */

    {
      name: "GRN",
      cell: (row) => (
        <>
          <span
            style={{ marginLeft: "12px" }}
            onClick={() =>
              threeTwoItemShowModal(
                row.GoodsMovement,
                "Goods Movement",
                threeGoodsMovementCols,
              )
            }
          >
            <i className="bi bi-calendar2-week iconTable"></i>
          </span>
          <span className="suppliersIcon"> {row.GoodsMovement?.length} </span>
        </>
      ),
      width: "100px",
    },
    {
      name: "INV",
      cell: (row) => (
        <>
          <span
            style={{ marginLeft: "12px" }}
            onClick={() =>
              threeTwoItemShowModal(
                row.InvoiceRegister,
                "Invoice Register",
                threeInvoiceRegisterCols,
              )
            }
          >
            <i className="bi bi-calendar2-week iconTable"></i>
          </span>
          <span className="suppliersIcon"> {row.InvoiceRegister?.length} </span>
        </>
      ),
      width: "100px",
    },

    {
      name: "GRN Qty",
      selector: (row) => row.grnQuantity || "--",
      cell: (row) => (
        <span className="fw-bold text-primary">{row.grnQuantity || "--"}</span>
      ),
      width: "130px",
    },
    {
      name: "GRN Total",
      selector: (row) => row.grnTotalPrice || "--",
      cell: (row) => (
        <span className="fw-bold text-primary">
          {row.grnTotalPrice || "--"}
        </span>
      ),
      width: "100px",
    },
    {
      name: "GRN Qty (Bal)",
      selector: (row) => row.grnBalancePurchaseQuantity ?? "--",
      cell: (row) => (
        <span className="fw-bold text-primary">
          {row.grnBalancePurchaseQuantity ?? "--"}
        </span>
      ),
      width: "120px",
    },
    {
      name: "INV Qty",
      selector: (row) => row.invoiceQuantity ?? "--",
      cell: (row) => (
        <span className="fw-bold text-success">
          {row.invoiceQuantity ?? "--"}
        </span>
      ),
      width: "110px",
    },
    {
      name: "INV Total",
      selector: (row) => row.invTotalPrice || "--",
      cell: (row) => (
        <span className="fw-bold text-success">
          {row.invTotalPrice || "--"}
        </span>
      ),
      width: "100px",
    },

    {
      name: "INV Tax",
      selector: (row) => row.invItemTaxValue || "--",
      cell: (row) => (
        <span className="fw-bold text-success">
          {row.invItemTaxValue || "--"}
        </span>
      ),
      width: "100px",
    },
    {
      name: "INV Gross",
      selector: (row) => row.invItemTotalValue || "--",
      cell: (row) => (
        <span className="fw-bold text-success">
          {row.invItemTotalValue || "--"}
        </span>
      ),
      width: "100px",
    },

    {
      name: "INV Qty (Bal)",
      selector: (row) => row.invBalancePurchaseQuantity ?? "--",
      cell: (row) => (
        <span className="fw-bold text-success">
          {row.invBalancePurchaseQuantity ?? "--"}
        </span>
      ),
      width: "130px",
    },
    // {
    //   name: "Status",
    //   selector: (row) => row.statusItem,
    //   cell: (row) => (
    //     <>
    //     {/* {(row?.purchaseQuantity === row?.grnQuantity === row?.invoiceQuantity) ?(<span> 3 Way-Match</span>):(<span></span>)

    //     } */}
    //     {row?.purchaseQuantity === row?.grnQuantity &&
    //   row?.grnQuantity === row?.invoiceQuantity ? (
    //     <span>3 Way-Match</span>
    //   ) : (
    //     <span> no match</span>
    //   )}

    //       {/* <TableStatusField status={row.statusItem} /> */}
    //     </>
    //   ),
    //   sortable: true,
    //   width: "160px",
    // },
    {
      name: "Status",
      selector: (row) => row.statusItem,
      cell: (row) => {
        const purchase = parseFloat(row?.purchaseQuantity);
        const grn = parseFloat(row?.grnQuantity);
        const invoice = parseFloat(row?.invoiceQuantity);

        const isThreeWayMatch = purchase === grn && grn === invoice;

        return (
          <>
            {isThreeWayMatch ? (
              <span className="bg-table-status bg-table-success-status">
                3 Way-Match
              </span>
            ) : (
              <span className="bg-table-status bg-table-danger-status">
                Mismatch
              </span> // Or leave empty: <span></span>
            )}
          </>
        );
      },
      sortable: true,
      width: "160px",
    },
  ];

  // Onclick on Table Header Button
  const handleAcknowledgeClick = async () => {
    let obj = {
      _id: getHeaderData?._id,
      purchasingDocumentNr: getHeaderData?.purchasingDocumentNr,
    };

    // if (getSelectedData.length > 0) {
    await ItemService.AcknowledgePO(obj).then((item) => {
      if (item?.status === 200) {
        toast.success(item?.message || "PO Acknowledged successfully", {
          duration: 3000,
          position: "top-right",
        });

        setDisabled(true);
        setToggleCleared(true);
        setSelectedData([]);

        let materialPO = {
          queryName: "getMaterialPO",
          module: "PO",
        };
        let servicePO = {
          queryName: "getServicePO",
          module: "PO",
        };
        let schedulingAgreement = {
          queryName: "getSchedulingAgreement",
          module: "PO",
        };

        if (getHeaderData.purchaseTypeCode === "MAT") {
          dispatch(getPurchaseOrder(materialPO));
        } else if (getHeaderData.purchaseTypeCode === "SER") {
          dispatch(getServicePO(servicePO));
        } else if (getHeaderData.purchaseTypeCode === "SA") {
          dispatch(getSchedulingAgreement(schedulingAgreement));
        }
      } else {
        toast.error(item?.message || "Please try again !!", {
          duration: 4000,
          position: "top-right",
        });
      }
    });
  };

  // Load GRN Historical data on page load
  const loadGrnHistoricalData = async () => {
    let obj = {
      page: 1,
      per_page: 10,
      purchasingDocumentNr: poNumber,
    };

    setLoading(true);
    await ItemService.getPOGrn(obj).then((item) => {
      // console.log(">> res! getPOGrn", item);
      if (item?.status === 200) {
        // toast.success(item?.message || "", {
        //   duration: 3000,
        //   position: "top-right",
        // });
        setGrnHistoricalData(item.data);
      } else {
        toast.error(item?.message || "Please try again !!", {
          duration: 4000,
          position: "top-right",
        });
      }
    });
    setLoading(false);
  };

  const handleHeaderFieldChange = (e) => {
    const { name, value } = e.target;
    setHeaderData((prev) => ({ ...prev, [name]: value }));
  };

  // Load ASN Historical data on page load
  const loadAsnHistoricalData = async () => {
    let obj = {
      page: 1,
      per_page: 10,
      purchasingDocumentNr: poNumber,
    };

    setLoading(true);
    await ItemService.getPOAsn(obj).then((item) => {
      // console.log(">> res! getPOAsn", item);
      if (item?.status === 200) {
        // toast.success(item?.message || "", {
        //   duration: 3000,
        //   position: "top-right",
        // });
        setAsnHistoricalData(item.data);
      } else {
        toast.error(item?.message || "Please try again !!", {
          duration: 4000,
          position: "top-right",
        });
      }
    });
    setLoading(false);
  };

  // Load Invoice Historical data on page load
  const loadInvoiceHistoricalData = async () => {
    let obj = {
      page: 1,
      per_page: 10,
      purchasingDocumentNr: poNumber,
    };

    setLoading(true);
    await ItemService.getPOInvoice(obj).then((item) => {
      // console.log(">> res! getPOInvoice", item);
      if (item?.status === 200) {
        // toast.success(item?.message || "", {
        //   duration: 3000,
        //   position: "top-right",
        // });
        setInvoiceHistoricalData(item.data);
      } else {
        toast.error(item?.message || "Please try again !!", {
          duration: 4000,
          position: "top-right",
        });
      }
    });
    setLoading(false);
  };

  // Load Ses Historical data on page load
  const loadSesHistoricalData = async () => {
    let obj = {
      page: 1,
      per_page: 10,
      purchasingDocumentNr: poNumber,
    };

    setLoading(true);
    await ItemService.getPOSes(obj).then((item) => {
      // console.log(">> res! getPOSes", item);
      if (item?.status === 200) {
        // toast.success(item?.message || "", {
        //   duration: 3000,
        //   position: "top-right",
        // });
        setSesHistoricalData(item.data);
      } else {
        toast.error(item?.message || "Please try again !!", {
          duration: 4000,
          position: "top-right",
        });
      }
    });
    setLoading(false);
  };

  //Selected from the Table
  const handleChange = ({ selectedRows }) => {
    setToggleCleared(false);
    setSelectedData(selectedRows);
    dispatch(addSelectedItemList(selectedRows));
    // if (selectedRows.length > 0) {
    //   setDisabled(false);
    // } else {
    //   setDisabled(true);
    // }
  };

  //Create ASN
  const createASN = () => {
    navigate(Constants.POCOLLABRATION_ASN_CREATION);
  };

  //Create SA ASN
  const createSAASN = () => {
    navigate(Constants.POCOLLABRATION_SA_ASN_CREATION);
  };

  //Create GRN
  const createGRN = () => {
    let obj = {
      asnNumber: "",
      subTransactionActivity: "PO",
    };
    dispatch(addSubTransactionActivity(obj));
    navigate(Constants.POCOLLABRATION_GRN_CREATION);
  };

  //Create SES
  const createSES = () => {
    let obj = {
      asnNumber: "",
      subTransactionActivity: "PO",
    };
    dispatch(addSubTransactionActivity(obj));
    navigate(Constants.POCOLLABRATION_SES_CREATION);
  };

  //Create Invoice
  const createInvoice = () => {
    navigate(Constants.POCOLLABRATION_INVOICE_CREATION);
  };

  //Create Invoice SES
  const createInvoiceSES = () => {
    navigate(Constants.POCOLLABRATION_INVOICE_CREATION_SES);
  };

  useEffect(() => {
    if (
      workflow?.workflow_record?.businessComponentId ===
      getConstantVar?.POBusinessComponentId
    ) {
      localStorage.setItem("menu", workflow?.page);
      localStorage.setItem("submenu", "-");
    } else {
      //console.log(">> getHeaderData", getHeaderData);
      if (getHeaderData.purchaseTypeCode === "MAT") {
        localStorage.setItem("menu", "Purchasing");
        localStorage.setItem("submenu", "Purchase Order");
      } else if (getHeaderData.purchaseTypeCode === "SER") {
        localStorage.setItem("menu", "Purchasing");
        localStorage.setItem("submenu", "Service PO");
      } else if (getHeaderData.purchaseTypeCode === "SA") {
        localStorage.setItem("menu", "Purchasing");
        localStorage.setItem("submenu", "Scheduling Agreement");
      }
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  const showServiceItemTable = (serviceData, itemNr) => {
    setItemNr(itemNr);
    setServiceData(serviceData);
    setServiceTableStatus(true);
  };
  const hide = () => {
    setServiceTableStatus(false);
  };

  return (
    <main className="dashboard main" id="main">
      <Layout />
      <Row className="justify-center subContent">
        <Col xs={12} md={12} className="rightSide">
          <div className="rightSideInner PageCommonCSS">
            <h2 className="mainTitle">
              Purchase Order Details :{" "}
              <span className="bg-table-status bg-table-documentNumber-status headerStatusDetailedPage">
                {poNumber}
              </span>
              <span className="bg-table-status bg-table-new-status headerStatusDetailedPage">
                {getHeaderData?.purchaseType}
              </span>
              <span>
                {getHeaderData?.headerStatus === "New" ? (
                  <span className="bg-table-status bg-table-new-status headerStatusDetailedPage">
                    {getHeaderData?.headerStatus}
                  </span>
                ) : getHeaderData?.headerStatus === "Created" ? (
                  <span className="bg-table-status bg-table-new-status headerStatusDetailedPage">
                    {getHeaderData?.headerStatus}
                  </span>
                ) : getHeaderData?.headerStatus === "Draft" ? (
                  <span className="bg-table-status bg-table-progress-status headerStatusDetailedPage">
                    {getHeaderData?.headerStatus}
                  </span>
                ) : getHeaderData?.headerStatus === "Acknowledged" ? (
                  <span className="bg-table-status bg-table-success-status headerStatusDetailedPage">
                    {getHeaderData?.headerStatus}
                  </span>
                ) : getHeaderData?.headerStatus === "Deleted" ? (
                  <span className="bg-table-status bg-table-delete-status headerStatusDetailedPage">
                    {getHeaderData?.headerStatus}
                  </span>
                ) : getHeaderData?.headerStatus === "Cancelled" ? (
                  <span className="bg-table-status bg-table-danger-status headerStatusDetailedPage">
                    {getHeaderData?.headerStatus}
                  </span>
                ) : (
                  getHeaderData?.headerStatus
                )}
              </span>
              <span className="bg-table-status bg-table-documentNumber-status headerStatusDetailedPage">
                {getHeaderData?.matchDesc}
              </span>
            </h2>
            <p className="subText">Purchase Order Information </p>
            <Row className="mb-2">
              <Row className="mb-2">
                <Col xs={12} className="d-flex justify-content-end gap-2">
                  {!isEditMode ? (
                    <button
                      className="btnTable btn-update"
                      onClick={handleUpdateClick}
                      disabled={["deleted", "cancelled"].includes(status)}
                    >
                      <i className="bi bi-pencil-square"></i> Modify
                    </button>
                  ) : (
                    <>
                      <button
                        className="btnTable btn-update"
                        onClick={
                          status === "draft"
                            ? handleConvertToPO
                            : handleSaveClick
                        }
                      >
                        <i
                          className={`bi ${status === "draft" ? "bi-arrow-repeat" : "bi-save"}`}
                        ></i>
                        {status === "draft" ? " Convert to PO" : " Save"}
                      </button>

                      <button
                        className="btn btn-secondary btn-update"
                        onClick={handleCancelClick}
                      >
                        <i className="bi bi-x-circle"></i> Cancel
                      </button>
                    </>
                  )}
                </Col>
              </Row>
            </Row>
            <hr />
            {workflows?.length > 0 && (
              <Col xs={12} md={12} lg={12} className="mb-3">
                <div className="d-flex flex-column">
                  <div className="d-flex justify-content-end mb-2">
                    <button
                      onClick={() => setShowWorkflow(!showWorkflow)}
                      className="icon-btn-sm"
                      title={
                        showWorkflow ? "Collapse Workflow" : "Expand Workflow"
                      }
                    >
                      <i
                        className={`bi ${
                          showWorkflow ? "bi-arrows-collapse" : "bi-diagram-3"
                        }`}
                        style={{ fontSize: "1.2rem" }}
                      ></i>
                    </button>
                  </div>

                  <div>
                    <ShowHorizontalStatus
                      rowdatamodal={workflows}
                      isDetailedView={showWorkflow}
                    />
                  </div>
                </div>
              </Col>
            )}
            {/* Workflow Component */}
            <WorkflowApproveReject workflowData={workflow} />
            {/* Header Details */}
            <div className="accordion mb-4" id="accordionExample">
              <div className="accordion-item">
                <h2 className="accordion-header">
                  <Row className="accordion-button">
                    <Col xs={1} md={1} lg={1} className="text-left arrowBtn">
                      <i
                        className={`bi ${
                          isCardVisible ? "bi-chevron-right" : "bi-chevron-down"
                        }`}
                        onClick={toggleCardVisibility}
                      ></i>
                    </Col>
                    <Col xs={1} md={1} lg={1} className="text-center logoBtn">
                      <span className="iconLogo">HR</span>
                    </Col>
                    <Col xs={12} md={2} lg={2}>
                      <span className="headerTitle">Header Details</span>
                      <span className="subHeaderTitle"> </span>
                    </Col>

                    {!workflow?.workflow_record?.businessComponentId &&
                      userInfo?.roles?.length > 0 &&
                      (userInfo?.roles[0].roleId === "VENDOR"
                        ? true
                        : false) && (
                        <>
                          {getHeaderData?.statusHeader === "Acknowledged" && (
                            <Col
                              xs={12}
                              md={8}
                              lg={8}
                              className="headerButtonAlign"
                            >
                              {config.createASN &&
                                getHeaderData?.purchaseTypeCode === "SA" && (
                                  <Col xs={4} md={2} lg={2} className="">
                                    <button
                                      className="btnTable"
                                      onClick={() => createSAASN()}
                                    >
                                      <i className="bi bi-calendar-check"></i>{" "}
                                      Create ASN
                                    </button>
                                  </Col>
                                )}

                              {config.createGRN &&
                                getHeaderData?.purchaseTypeCode === "MAT" && (
                                  <>
                                    {getHeaderData.process === "ASN" && (
                                      <Col xs={4} md={2} lg={2} className="">
                                        <button
                                          className="btnTable"
                                          onClick={() => createASN()}
                                        >
                                          <i className="bi bi-calendar-check"></i>{" "}
                                          Create ASN
                                        </button>
                                      </Col>
                                    )}

                                    {getHeaderData.process === "GRN" && (
                                      <Col xs={4} md={2} lg={2} className="">
                                        <button
                                          className="btnTable"
                                          onClick={() => createGRN()}
                                        >
                                          <i className="bi bi-truck"></i> Create
                                          Goods Receipt
                                        </button>
                                      </Col>
                                    )}
                                  </>
                                )}

                              {config.createSES &&
                                getHeaderData?.purchaseTypeCode === "SER" && (
                                  <Col xs={4} md={2} lg={2} className="">
                                    <button
                                      className="btnTable"
                                      onClick={() => createSES()}
                                    >
                                      <i className="bi bi-file-spreadsheet"></i>{" "}
                                      Create SES
                                    </button>
                                  </Col>
                                )}

                              {config.createInvoice &&
                                getHeaderData?.purchaseTypeCode === "MAT" && (
                                  <>
                                    {getHeaderData.process === "GRN" && (
                                      <Col xs={4} md={2} lg={2} className="">
                                        <button
                                          className="btnTable"
                                          onClick={() => createInvoice()}
                                        >
                                          <i className="bi bi-currency-dollar"></i>{" "}
                                          Create Invoice
                                        </button>
                                      </Col>
                                    )}
                                  </>
                                )}

                              {getHeaderData?.purchaseTypeCode === "SER" && (
                                <Col xs={4} md={2} lg={2} className="">
                                  <button
                                    className="btnTable"
                                    onClick={() => createInvoiceSES()}
                                  >
                                    <i className="bi bi-currency-dollar"></i>{" "}
                                    Create Invoice
                                  </button>
                                </Col>
                              )}
                            </Col>
                          )}
                        </>
                      )}
                  </Row>
                </h2>

                <div
                  className={`accordion-collapse collapse show ${
                    isCardVisible ? "visible" : ""
                  }`}
                >
                  <div className="accordion-body">
                    <Row className="pt-2 pb-4">
                      <Col
                        xs={12}
                        md={4}
                        lg={4}
                        className="commTopButtonRightLeftPadding"
                      >
                        <InputField
                          className="inputBox"
                          // label="Document Number"
                          label={
                            <>
                              <i className="bi bi-hash labelIcon"></i>
                              Document Number
                            </>
                          }
                          name="purchasingDocumentNr"
                          placeholder=""
                          value={getHeaderData?.purchasingDocumentNr || ""}
                          disabled={true}
                          // disabled={!isEditMode}
                          onChange={handleHeaderFieldChange}
                        />
                      </Col>

                      <Col
                        xs={12}
                        md={4}
                        lg={4}
                        className="commTopButtonRightLeftPadding"
                      >
                        <InputField
                          className="inputBox"
                          // label="Document Date"
                          label={
                            <>
                              <i className="bi bi-calendar-event labelIcon"></i>
                              Document Date
                            </>
                          }
                          name="purchasingDocumentDate"
                          placeholder=""
                          value={getHeaderData?.purchasingDocumentDate || ""}
                          disabled={true}
                          // disabled={!isEditMode}
                          onChange={handleHeaderFieldChange}
                        />
                      </Col>
                      <Col
                        xs={12}
                        md={4}
                        lg={4}
                        className="commTopButtonRightLeftPadding"
                      >
                        <InputField
                          className="inputBox"
                          // label="Net Value"
                          label={
                            <>
                              <i className="bi bi-cash-stack labelIcon"></i>
                              Net Value
                            </>
                          }
                          name="purchasingDocumentValue"
                          placeholder=""
                          value={currencyFormat(
                            Number(
                              getHeaderData?.purchasingDocumentValue,
                            ).toFixed(2),
                          )}
                          disabled={true}
                          onChange={handleHeaderFieldChange}
                        />
                      </Col>
                      <Col
                        xs={12}
                        md={4}
                        lg={4}
                        className="commTopButtonRightLeftPadding"
                      >
                        <InputField
                          className="inputBox"
                          // label="Currency"
                          label={
                            <>
                              <i className="bi bi-cash-stack labelIcon"></i>
                              Net Value
                            </>
                          }
                          name="currency"
                          placeholder=""
                          value={`${getHeaderData?.currencyCode} - ${getHeaderData?.currency}`}
                          // disabled={!isEditMode}
                          disabled={true}
                          onChange={handleHeaderFieldChange}
                        />
                      </Col>

                      <Col
                        xs={12}
                        md={4}
                        lg={4}
                        className="commTopButtonRightLeftPadding"
                      >
                        <InputField
                          className="inputBox"
                          // label="Vendor Code"
                          label={
                            <>
                              <i className="bi bi-person-badge labelIcon"></i>
                              Vendor Code
                            </>
                          }
                          name="vendorCode"
                          placeholder=""
                          value={getHeaderData?.vendorCode || ""}
                          disabled={true}
                          // disabled={!isEditMode}
                          onChange={handleHeaderFieldChange}
                        />
                      </Col>
                      <Col
                        xs={12}
                        md={4}
                        lg={4}
                        className="commTopButtonRightLeftPadding"
                      >
                        <InputField
                          className="inputBox"
                          // label="Vendor Name"
                          label={
                            <>
                              <i className="bi bi-person-vcard labelIcon"></i>
                              Vendor Name
                            </>
                          }
                          name="vendorName"
                          placeholder=""
                          value={getHeaderData?.vendorName || ""}
                          disabled={true}
                          // disabled={!isEditMode}
                          onChange={handleHeaderFieldChange}
                        />
                      </Col>
                      <Col
                        xs={12}
                        md={4}
                        lg={4}
                        className="commTopButtonRightLeftPadding"
                      >
                        <InputField
                          className="inputBox"
                          // label="Payment Terms"
                          label={
                            <>
                              <i className="bi bi-credit-card labelIcon"></i>
                              Payment Terms
                            </>
                          }
                          name="paymentTerms"
                          placeholder=""
                          value={getHeaderData?.paymentTerms || ""}
                          // disabled={!isEditMode}
                          disabled={true}
                          onChange={handleHeaderFieldChange}
                        />
                      </Col>
                      <Col
                        xs={12}
                        md={4}
                        lg={4}
                        className="commTopButtonRightLeftPadding"
                      >
                        <InputField
                          className="inputBox"
                          // label="Inco Terms"
                          label={
                            <>
                              <i className="bi bi-credit-card labelIcon"></i>
                              Payment Terms
                            </>
                          }
                          name="incoTerms"
                          placeholder=""
                          value={getHeaderData?.incoTerms || ""}
                          // disabled={!isEditMode}
                          disabled={true}
                          onChange={handleHeaderFieldChange}
                        />
                      </Col>
                      <Col
                        xs={12}
                        md={4}
                        lg={4}
                        className="commTopButtonRightLeftPadding"
                      >
                        <InputField
                          className="inputBox"
                          // label="Company Code "
                          label={
                            <>
                              <i className="bi bi-building-check labelIcon"></i>
                              Company Code
                            </>
                          }
                          name="companyCodeCode"
                          id="companyCodeCode"
                          value={getHeaderData?.companyCodeCode}
                          // disabled={!isEditMode}
                          disabled={true}
                          onChange={handleHeaderFieldChange}
                        />
                      </Col>
                      <Col
                        xs={12}
                        md={4}
                        lg={4}
                        className="commTopButtonRightLeftPadding"
                      >
                        <InputField
                          className="inputBox"
                          // label="Purchse Type"
                          label={
                            <>
                              <i className="bi bi-cart labelIcon"></i>
                              Purchase Type
                            </>
                          }
                          name="purchasingRemark"
                          placeholder=""
                          value={getHeaderData?.purchaseType || ""}
                          // disabled={!isEditMode}
                          disabled={true}
                          onChange={handleHeaderFieldChange}
                        />
                      </Col>
                      <Col
                        xs={12}
                        md={4}
                        lg={4}
                        className="commTopButtonRightLeftPadding mt-4 pt-3"
                      >
                        <div>
                          <label className="block text-sm font-medium leading-6 text-gray-900 infoIconAccordion">
                            <>
                              <i className="bi bi-card-text labelIcon"></i>
                              Header Text
                            </>
                          </label>
                          <span
                            style={{ marginLeft: "15px" }}
                            onClick={() =>
                              headerTextShowModal(getHeaderData?.headerTextData)
                            }
                          >
                            <i className="bi bi-calendar2-week iconTable"></i>
                          </span>
                          <span className="suppliersIcon">
                            {" "}
                            {getHeaderData?.headerTextData?.length || 0}{" "}
                          </span>
                        </div>
                      </Col>
                    </Row>
                  </div>
                </div>
              </div>
            </div>

            {/* Line Itemss */}
            <div className="accordion mb-4" id="accordionExample">
              <div className="accordion-item">
                <h2 className="accordion-header">
                  <Row className="accordion-button">
                    <Col xs={1} md={1} lg={1} className="text-left arrowBtn">
                      <i
                        className={`bi ${
                          isCardVisible2
                            ? "bi-chevron-right"
                            : "bi-chevron-down"
                        }`}
                        onClick={toggleCardVisibility2}
                      ></i>
                    </Col>
                    <Col xs={1} md={1} lg={1} className="text-center logoBtn">
                      <span className="iconLogo">LI</span>
                    </Col>
                    <Col xs={12} md={3} lg={3}>
                      <span className="headerTitle">Line Items</span>
                      <span className="subHeaderTitle"> </span>
                    </Col>

                    <Col xs={12} md={8} lg={8} className="headerButtonAlign">
                      {userInfo?.roles?.length > 0 &&
                        (userInfo?.roles[0].roleId === "VENDOR"
                          ? true
                          : false) &&
                        getHeaderData?.statusHeader !== "Acknowledged" && (
                          <>
                            <Col xs={4} md={2} lg={2} className="">
                              <button
                                className="btnTable"
                                onClick={() => handleAcknowledgeClick()}
                                disabled={disabled}
                              >
                                <i className="bi bi-check-circle"></i>{" "}
                                Acknowledge
                              </button>
                            </Col>
                          </>
                        )}
                      {isEditMode &&
                        getHeaderData?.purchaseTypeCode === "MAT" && (
                          <button
                            className="btnTable"
                            style={{ width: "auto", padding: "6px 16px" }}
                            onClick={addPOItemRow}
                          >
                            <i className="bi bi-plus-lg"></i> Add
                          </button>
                        )}
                      <Col xs={2} md={2} lg={2} className="">
                        {getServiceTableStatus ? (
                          <button className="btn btn-danger" onClick={hide}>
                            <i className="bi bi-eye-slash-fill"></i> Hide
                            Serivces
                          </button>
                        ) : (
                          " "
                        )}
                      </Col>
                    </Col>
                  </Row>
                </h2>

                <div
                  // id="acc"
                  className={`accordion-collapse collapse show ${
                    isCardVisible2 ? "visible" : ""
                  }`}
                  // aria-labelledby="headingOne"
                  // data-bs-parent="#accordionExample"
                >
                  <div className="accordion-body">
                    <Row>
                      <Col xs={12} md={12} lg={12}>
                        {/* <DataTable
                          title=""
                          columns={
                            getHeaderData?.purchaseTypeCode === "MAT"
                              ? columns
                              : getHeaderData?.purchaseTypeCode === "SER"
                                ? columnsService
                                : getHeaderData?.purchaseTypeCode === "SA"
                                  ? columnsSchedule
                                  : POLineItemInitialCol
                          }
                          data={data}
                          progressPending={loading}
                          pagination
                          // paginationServer
                          // paginationTotalRows={totalRows}
                          // onChangeRowsPerPage={handlePerRowsChange}
                          // onChangePage={handlePageChange}
                          selectableRows
                          paginationRowsPerPageOptions={Constants.ROW_PER_PAGE}
                          onSelectedRowsChange={handleChange}
                          clearSelectedRows={toggleCleared}
                        /> */}
                        <DataTable
                          title=""
                          columns={
                            getHeaderData?.purchaseTypeCode === "MAT"
                              ? POLineItemInitialCol
                              : getHeaderData?.purchaseTypeCode === "SER"
                                ? columnsService
                                : getHeaderData?.purchaseTypeCode === "SA"
                                  ? columnsSchedule
                                  : POLineItemInitialCol
                          }
                          data={
                            getHeaderData?.purchaseTypeCode === "MAT"
                              ? getPOLineItemsData
                              : data
                          }
                          progressPending={loading}
                          pagination
                          selectableRows
                          paginationRowsPerPageOptions={Constants.ROW_PER_PAGE}
                          onSelectedRowsChange={handleChange}
                          clearSelectedRows={toggleCleared}
                        />
                      </Col>
                    </Row>
                  </div>
                </div>
              </div>
            </div>

            {/* Service Itemss */}
            {getServiceTableStatus && (
              <div
                ref={divRef}
                className="accordion mb-4"
                id="accordionExample"
              >
                <div className="accordion-item">
                  <h2 className="accordion-header">
                    <Row className="accordion-button">
                      <Col xs={1} md={1} lg={1} className="text-left arrowBtn">
                        <i
                          className={`bi ${
                            isCardVisible2
                              ? "bi-chevron-right"
                              : "bi-chevron-down"
                          }`}
                          onClick={toggleCardVisibility2}
                        ></i>
                      </Col>
                      <Col xs={1} md={1} lg={1} className="text-center logoBtn">
                        <span className="iconLogo">LI</span>
                      </Col>
                      <Col xs={12} md={9} lg={9}>
                        <span className="headerTitle">
                          {getHeaderData.purchaseTypeCode === "SER"
                            ? `Services - PO Item: ${getItemNr}`
                            : getHeaderData.purchaseTypeCode === "SA"
                              ? `Schedules - SA Item: ${getItemNr}`
                              : ""}
                        </span>
                        <span className="subHeaderTitle"> </span>
                      </Col>

                      {/* <Col xs={2} md={1} lg={1} className="">
                        <div className="filter">
                          <span
                            className="icon hide headerIcon "
                            data-bs-toggle="dropdown"
                            aria-expanded="true"
                            onClick={()=>hide()}
                          >
                            <i className="bi bi-x-circle"></i>
                          </span>
                        </div>
                      </Col> */}
                    </Row>
                  </h2>

                  <div
                    // id="acc"
                    className={`accordion-collapse collapse show ${
                      isCardVisible2 ? "visible" : ""
                    }`}
                    // aria-labelledby="headingOne"
                    // data-bs-parent="#accordionExample"
                  >
                    <div className="accordion-body">
                      <Row>
                        <Col xs={12} md={12} lg={12}>
                          <DataTable
                            title=""
                            columns={
                              getHeaderData.purchaseTypeCode === "SER"
                                ? serviceColInfo
                                : getHeaderData.purchaseTypeCode === "SA"
                                  ? scheduleColInfo
                                  : ""
                            }
                            data={getServiceData}
                            progressPending={loading}
                            pagination
                            // paginationServer
                            // paginationTotalRows={totalRows}
                            // onChangeRowsPerPage={handlePerRowsChange}
                            // onChangePage={handlePageChange}
                            selectableRows
                            paginationRowsPerPageOptions={
                              Constants.ROW_PER_PAGE
                            }
                            onSelectedRowsChange={handleChange}
                            clearSelectedRows={toggleCleared}
                          />
                        </Col>
                      </Row>
                    </div>
                  </div>
                </div>
              </div>
            )}

            {/* Historical ASN List */}
            {getAsnHistoricalData.length > 0 && (
              <>
                <div className="accordion mb-4" id="accordionExample">
                  <div className="accordion-item">
                    <h2 className="accordion-header">
                      <Row className="accordion-button">
                        <Col
                          xs={1}
                          md={1}
                          lg={1}
                          className="text-left arrowBtn"
                        >
                          <i
                            className={`bi ${
                              isCardVisible4
                                ? "bi-chevron-right"
                                : "bi-chevron-down"
                            }`}
                            onClick={toggleCardVisibility4}
                          ></i>
                        </Col>
                        <Col
                          xs={1}
                          md={1}
                          lg={1}
                          className="text-center logoBtn"
                        >
                          <span className="iconLogo">SL</span>
                        </Col>
                        <Col xs={5} md={8} lg={8}>
                          <span className="headerTitle">Historical ASN</span>
                          <span className="subHeaderTitle">
                            View of ASN List{" "}
                          </span>
                        </Col>

                        {/* <Col xs={2} md={1} lg={1} className="">
                          <POCollabrationCommonFillter />
                        </Col> */}
                      </Row>
                    </h2>

                    <div
                      // id="acc"
                      className={`accordion-collapse collapse show ${
                        isCardVisible4 ? "visible" : ""
                      }`}
                      // aria-labelledby="headingOne"
                      // data-bs-parent="#accordionExample"
                    >
                      <div className="accordion-body">
                        <Row>
                          <Col xs={12} md={12} lg={12}>
                            <DataTable
                              title=""
                              columns={asnHistoryColInfo}
                              data={getAsnHistoricalData}
                              progressPending={loading}
                              paginationRowsPerPageOptions={
                                Constants.ROW_PER_PAGE
                              }
                              pagination
                              // paginationServer
                              // paginationTotalRows={totalRows}
                              // onChangeRowsPerPage={handlePerRowsChange}
                              // onChangePage={handlePageChange}
                              selectableRows
                            />
                          </Col>
                        </Row>
                      </div>
                    </div>
                  </div>
                </div>
              </>
            )}

            {/* Historical Goods Received Note List */}
            {getGrnHistoricalData.length > 0 && (
              <>
                <div className="accordion mb-4" id="accordionExample">
                  <div className="accordion-item">
                    <h2 className="accordion-header">
                      <Row className="accordion-button">
                        <Col
                          xs={1}
                          md={1}
                          lg={1}
                          className="text-left arrowBtn"
                        >
                          <i
                            className={`bi ${
                              isCardVisible3
                                ? "bi-chevron-right"
                                : "bi-chevron-down"
                            }`}
                            onClick={toggleCardVisibility3}
                          ></i>
                        </Col>
                        <Col
                          xs={1}
                          md={1}
                          lg={1}
                          className="text-center logoBtn"
                        >
                          <span className="iconLogo">SL</span>
                        </Col>
                        <Col xs={12} md={8} lg={8}>
                          <span className="headerTitle">Historical GRN</span>
                          <span className="subHeaderTitle">
                            View of Goods Received Note List{" "}
                          </span>
                        </Col>

                        {/* <Col xs={2} md={1} lg={1} className="">
                          <POCollabrationCommonFillter />
                        </Col> */}
                      </Row>
                    </h2>

                    <div
                      // id="acc"
                      className={`accordion-collapse collapse show ${
                        isCardVisible3 ? "visible" : ""
                      }`}
                      // aria-labelledby="headingOne"
                      // data-bs-parent="#accordionExample"
                    >
                      <div className="accordion-body">
                        <Row>
                          <Col xs={12} md={12} lg={12}>
                            <DataTable
                              title=""
                              columns={grnHistoryColInfo}
                              data={getGrnHistoricalData}
                              progressPending={loading}
                              paginationRowsPerPageOptions={
                                Constants.ROW_PER_PAGE
                              }
                              pagination
                              // paginationServer
                              // paginationTotalRows={totalRows}
                              // onChangeRowsPerPage={handlePerRowsChange}
                              // onChangePage={handlePageChange}
                              selectableRows
                            />
                          </Col>
                        </Row>
                      </div>
                    </div>
                  </div>
                </div>
              </>
            )}

            {/* Historical Invoice List */}
            {getInvoiceHistoricalData.length > 0 && (
              <>
                <div className="accordion mb-4" id="accordionExample">
                  <div className="accordion-item">
                    <h2 className="accordion-header">
                      <Row className="accordion-button">
                        <Col
                          xs={1}
                          md={1}
                          lg={1}
                          className="text-left arrowBtn"
                        >
                          <i
                            className={`bi ${
                              isCardVisible3
                                ? "bi-chevron-right"
                                : "bi-chevron-down"
                            }`}
                            onClick={toggleCardVisibility3}
                          ></i>
                        </Col>
                        <Col
                          xs={1}
                          md={1}
                          lg={1}
                          className="text-center logoBtn"
                        >
                          <span className="iconLogo">SL</span>
                        </Col>
                        <Col xs={12} md={8} lg={8}>
                          <span className="headerTitle">
                            Historical Invoice
                          </span>
                          <span className="subHeaderTitle">
                            View of Invoice List{" "}
                          </span>
                        </Col>

                        {/* <Col xs={2} md={1} lg={1} className="">
                          <POCollabrationCommonFillter />
                        </Col> */}
                      </Row>
                    </h2>

                    <div
                      // id="acc"
                      className={`accordion-collapse collapse show ${
                        isCardVisible3 ? "visible" : ""
                      }`}
                      // aria-labelledby="headingOne"
                      // data-bs-parent="#accordionExample"
                    >
                      <div className="accordion-body">
                        <Row>
                          <Col xs={12} md={12} lg={12}>
                            <DataTable
                              title=""
                              columns={invoiceDataColumns}
                              data={getInvoiceHistoricalData}
                              progressPending={loading}
                              paginationRowsPerPageOptions={
                                Constants.ROW_PER_PAGE
                              }
                              pagination
                              // paginationServer
                              // paginationTotalRows={totalRows}
                              // onChangeRowsPerPage={handlePerRowsChange}
                              // onChangePage={handlePageChange}
                              selectableRows
                            />
                          </Col>
                        </Row>
                      </div>
                    </div>
                  </div>
                </div>
              </>
            )}

            {/* Historical SES List */}
            {getSesHistoricalData.length > 0 && (
              <>
                <div className="accordion mb-4" id="accordionExample">
                  <div className="accordion-item">
                    <h2 className="accordion-header">
                      <Row className="accordion-button">
                        <Col
                          xs={1}
                          md={1}
                          lg={1}
                          className="text-left arrowBtn"
                        >
                          <i
                            className={`bi ${
                              isCardVisible3
                                ? "bi-chevron-right"
                                : "bi-chevron-down"
                            }`}
                            onClick={toggleCardVisibility3}
                          ></i>
                        </Col>
                        <Col
                          xs={1}
                          md={1}
                          lg={1}
                          className="text-center logoBtn"
                        >
                          <span className="iconLogo">SL</span>
                        </Col>
                        <Col xs={12} md={8} lg={8}>
                          <span className="headerTitle">Historical SES</span>
                          <span className="subHeaderTitle">
                            View of SES List{" "}
                          </span>
                        </Col>

                        {/* <Col xs={2} md={1} lg={1} className="">
                          <POCollabrationCommonFillter />
                        </Col> */}
                      </Row>
                    </h2>

                    <div
                      // id="acc"
                      className={`accordion-collapse collapse show ${
                        isCardVisible3 ? "visible" : ""
                      }`}
                      // aria-labelledby="headingOne"
                      // data-bs-parent="#accordionExample"
                    >
                      <div className="accordion-body">
                        <Row>
                          <Col xs={12} md={12} lg={12}>
                            <DataTable
                              title=""
                              columns={sesHistoryColInfo}
                              data={getSesHistoricalData}
                              progressPending={loading}
                              paginationRowsPerPageOptions={
                                Constants.ROW_PER_PAGE
                              }
                              pagination
                              // paginationServer
                              // paginationTotalRows={totalRows}
                              // onChangeRowsPerPage={handlePerRowsChange}
                              // onChangePage={handlePageChange}
                              selectableRows
                            />
                          </Col>
                        </Row>
                      </div>
                    </div>
                  </div>
                </div>
              </>
            )}

            {getHeaderData?.statusHeader === "Acknowledged" &&
              (userData?.data?.category === "VENDOR" ? (
                ""
              ) : (
                <>
                  {(getHeaderData?.matchCode === "M1" ||
                    getHeaderData?.matchCode === "M3") && (
                    <>
                      {/* Two-way matching - PO /Invoice */}
                      <div className="accordion mb-4" id="accordionExample">
                        <div className="accordion-item">
                          <h2 className="accordion-header">
                            <Row className="accordion-button">
                              <Col
                                xs={1}
                                md={1}
                                lg={1}
                                className="text-left arrowBtn"
                              >
                                <i
                                  className={`bi ${
                                    isCardVisible5
                                      ? "bi-chevron-right"
                                      : "bi-chevron-down"
                                  }`}
                                  onClick={toggleCardVisibility5}
                                ></i>
                              </Col>
                              <Col
                                xs={1}
                                md={1}
                                lg={1}
                                className="text-center logoBtn"
                              >
                                <span className="iconLogo">TW</span>
                              </Col>
                              <Col xs={12} md={8} lg={8}>
                                <span className="headerTitle">
                                  Two-Way Matching - Purchase Order /Invoice
                                </span>
                                <span className="subHeaderTitle">
                                  View of Two Way List{" "}
                                </span>
                              </Col>

                              {/* <Col xs={2} md={1} lg={1} className="">
                          <POCollabrationCommonFillter />
                        </Col> */}
                            </Row>
                          </h2>

                          <div
                            // id="acc"
                            className={`accordion-collapse collapse show ${
                              isCardVisible5 ? "visible" : ""
                            }`}
                            // aria-labelledby="headingOne"
                            // data-bs-parent="#accordionExample"
                          >
                            <div className="accordion-body">
                              <Row>
                                <Col xs={12} md={12} lg={12}>
                                  <DataTable
                                    title=""
                                    columns={twoWayColInfo}
                                    data={getThreeWayMatch}
                                    progressPending={loading}
                                    paginationRowsPerPageOptions={
                                      Constants.ROW_PER_PAGE
                                    }
                                    pagination
                                    // paginationServer
                                    // paginationTotalRows={totalRows}
                                    // onChangeRowsPerPage={handlePerRowsChange}
                                    // onChangePage={handlePageChange}
                                    selectableRows
                                  />
                                </Col>
                              </Row>
                            </div>
                          </div>
                        </div>
                      </div>
                    </>
                  )}
                  {(getHeaderData?.matchCode === "M2" ||
                    getHeaderData?.matchCode === "M3") && (
                    <>
                      {/* Three-way matching - PO /Invoice /GRN  */}
                      <div className="accordion mb-4" id="accordionExample">
                        <div className="accordion-item">
                          <h2 className="accordion-header">
                            <Row className="accordion-button">
                              <Col
                                xs={1}
                                md={1}
                                lg={1}
                                className="text-left arrowBtn"
                              >
                                <i
                                  className={`bi ${
                                    isCardVisible6
                                      ? "bi-chevron-right"
                                      : "bi-chevron-down"
                                  }`}
                                  onClick={toggleCardVisibility6}
                                ></i>
                              </Col>
                              <Col
                                xs={1}
                                md={1}
                                lg={1}
                                className="text-center logoBtn"
                              >
                                <span className="iconLogo">TH</span>
                              </Col>
                              <Col xs={12} md={8} lg={8}>
                                <span className="headerTitle">
                                  Three-Way Matching - Purchase Order /Invoice
                                  /Goods Receipt
                                </span>
                                <span className="subHeaderTitle">
                                  View of Three Way List{" "}
                                </span>
                              </Col>

                              {/* <Col xs={2} md={1} lg={1} className="">
                          <POCollabrationCommonFillter />
                        </Col> */}
                            </Row>
                          </h2>

                          <div
                            // id="acc"
                            className={`accordion-collapse collapse show ${
                              isCardVisible6 ? "visible" : ""
                            }`}
                            // aria-labelledby="headingOne"
                            // data-bs-parent="#accordionExample"
                          >
                            <div className="accordion-body">
                              <Row>
                                <Col xs={12} md={12} lg={12}>
                                  <DataTable
                                    title=""
                                    columns={threeWayColInfo}
                                    data={getThreeWayMatch}
                                    progressPending={loading}
                                    paginationRowsPerPageOptions={
                                      Constants.ROW_PER_PAGE
                                    }
                                    pagination
                                    // paginationServer
                                    // paginationTotalRows={totalRows}
                                    // onChangeRowsPerPage={handlePerRowsChange}
                                    // onChangePage={handlePageChange}
                                    selectableRows
                                  />
                                </Col>
                              </Row>
                            </div>
                          </div>
                        </div>
                      </div>
                    </>
                  )}
                </>
              ))}
          </div>
        </Col>
      </Row>

      {/* Item Text  */}
      <CommonItemLevelDatatableModal
        show={itemLevelModalShow}
        onHide={() => itemLevelHideModal()}
        columns={getItemLevelColumns}
        data={getItemLevelData}
        title={getModalTitle}
      />

      {/* Header Text  */}
      <CommonItemLevelDatatableModal
        show={getViewHeaderText}
        onHide={() => headerTextHideModal()}
        columns={getItemLevelColumns}
        data={getItemLevelData}
        title={getModalTitle}
      />

      {/* ASN Item Text  */}
      <CommonItemLevelDatatableModal
        show={getASNitemLevelModalShow}
        onHide={() => ASNItemLevelHideModal()}
        columns={ASNLineItemColInfo}
        data={getItemLevelData}
        title={getModalTitle}
      />

      {/* GRN Item Text  */}
      <CommonItemLevelDatatableModal
        show={getGRNitemLevelModalShow}
        onHide={() => GRNLItemLevelHideModal()}
        columns={GRNLineItemColInfo}
        data={getItemLevelData}
        title={getModalTitle}
      />

      {/* Invoice Item Text  */}
      <CommonItemLevelDatatableModal
        show={getInvoiceitemLevelModalShow}
        onHide={() => InvoiceItemLevelHideModal()}
        columns={InvoiceLineItemColInfo}
        data={getItemLevelData}
        title={getModalTitle}
      />

      {/* Invoice Item Text  */}
      <CommonItemLevelDatatableModal
        show={getSESitemLevelModalShow}
        onHide={() => SESLItemLevelHideModal()}
        columns={SESLineItemColInfo}
        data={getItemLevelData}
        title={getModalTitle}
      />

      {/* ThreeTwo Text  */}
      <CommonItemLevelDatatableModal
        show={getThreeTwoModalShow}
        onHide={() => threeTwoItemHideModal()}
        columns={getItemLevelColumns}
        data={getItemLevelData}
        title={getModalTitle}
      />
      <DraftModal
        show={showDraftModal}
        onHide={() => setShowDraftModal(false)}
        type="PO"
        title="Save as Draft"
        formData={getHeaderData}
        onConfirm={handleSaveAsDraft}
        onDiscard={handleDiscardDraft}
      />
    </main>
  );
};

export default PurchaseOrderDetailPageWH;
